// Norvig — Norwegian (master)
const no = {
  meta: {
    siteTitle: 'Norvig — bemanning til helse og omsorg',
    siteDescription: 'Norvig kobler sykepleiere, helsefagarbeidere og andre fagfolk direkte til norske kommuner. Helse & omsorg først — oppvekst & utdanning i tillegg.',
  },
  common: {
    brandHomeLabel: 'Norvig hjem',
    learnMore: 'Les mer',
    backToHome: 'Tilbake til Norvig',
    backToTop: 'Tilbake til topp',
    soonBadge: 'Kommer snart',
  },
  nav: {
    sectors: 'Sektorer',
    howItWorks: 'Slik fungerer det',
    aboutNorway: 'Om Norge',
    horisont: 'Horisont',
    aboutUs: 'Om oss',
    stories: 'Historier',
    candidates: 'Kandidater',
    login: 'Logg inn',
    register: 'Registrer deg',
    openMenu: 'Åpne meny',
    closeMenu: 'Lukk meny',
    selectLanguage: 'Velg språk',
    forProfessionals: 'For fagarbeidere',
    forEmployers: 'For kommuner',
    professionalRole: 'Fagarbeider',
    municipalityRole: 'Kommune',
    registerNew: 'Registrer deg som ny',
    contact: 'Kontakt',
  },
  auth: {
    common: {
      backHome: 'Tilbake til forsiden',
      brand: {
        eyebrow: 'NORVIG · 2026',
        title: 'Et nytt',
        titleAccent: 'kapittel begynner.',
        sub: 'Norvigs plattform kobler helsepersonell og andre fagfolk rett til norske kommuner — ingen mellomledd, full oppfølging.',
        bullets: [
          'AI-drevet matching på sekunder',
          'Verifiserte kommuner — GDPR-kompatibelt',
          'Helt gratis for fagarbeidere — åpen prismodell for kommuner',
        ],
        footnote: 'Bygd med omtanke for fagarbeidere i Norge.',
      },
      orDivider: 'eller',
      labels: {
        email: 'E-post',
        password: 'Passord',
        name: 'Fullt navn',
        role: 'Jeg er',
        roleProfessional: 'Fagarbeider',
        roleEmployer: 'Kommune',
      },
      placeholders: {
        email: 'din@epost.no',
        password: '••••••••',
        name: 'Ditt fulle navn',
      },
      genericError: 'Noe gikk galt. Prøv igjen.',
      rateLimited: 'Du har sendt for mange forsøk. Vent noen minutter og prøv igjen.',
    },
    quotes: {
      login: 'Skap din nye livsvei i Norge.',
      signupProfessional: 'Norge trenger deg. Norvig hjelper deg finne veien.',
      signupEmployer: 'Rekruttering med omtanke. Ansettelser som varer.',
    },
    login: {
      eyebrow: 'Nº 01 — VELKOMMEN TILBAKE',
      title: 'Logg inn',
      titleAccent: 'igjen.',
      sub: 'Fortsett der du slapp.',
      submit: 'Logg inn',
      loading: 'Vennligst vent…',
      lockedOut: 'Kontoen er midlertidig sperret etter for mange feilede innloggingsforsøk. Prøv igjen om ca. 15 minutter.',
      google: 'Fortsett med Google',
      noAccount: 'Ny her?',
      goToSignup: 'Opprett konto →',
      welcomeBackToast: 'Velkommen tilbake.',
      passwordChangedToast: 'Du har endret passord. Vennligst logg inn på nytt.',
      failed: 'Innlogging feilet',
      quickLoginEyebrow: 'HURTIGINNLOGGING (TESTBRUKERE)',
      quickLoginHint: 'Klikk for å fylle inn — deretter «Logg inn».',
      quickLoginAdmin: 'Admin',
      quickLoginEmployer: 'Kommune',
      quickLoginProfessional: 'Fagarbeider',
      forgotLink: 'Glemt passord?',
    },
    forgot: {
      eyebrow: 'Nº 03 — GLEMT PASSORD',
      title: 'Glemt',
      titleAccent: 'passord?',
      sub: 'Skriv inn e-posten din, så sender vi instruksjoner for å sette nytt passord.',
      submit: 'Send reset-e-post',
      loading: 'Sender …',
      successTitle: 'Sjekk e-posten din',
      successBody: 'Hvis kontoen finnes, har vi sendt en e-post med instruksjoner. Lenken er gyldig i 30 minutter.',
      backToLogin: 'Husker du passordet? Logg inn →',
      demoBannerTitle: 'DEMO-MODUS — e-post er ikke konfigurert enda',
      demoBannerSub: 'I produksjon ville denne lenken kommet på e-post.',
      demoBannerOpenLink: 'Åpne reset-lenken',
      demoBannerTokenLabel: 'Token',
    },
    reset: {
      eyebrow: 'Nº 04 — NYTT PASSORD',
      title: 'Sett',
      titleAccent: 'nytt passord.',
      sub: 'Velg et nytt passord på minst 8 tegn.',
      newPassword: 'Nytt passord',
      confirmPassword: 'Bekreft nytt passord',
      submit: 'Tilbakestill passord',
      loading: 'Oppdaterer …',
      mismatch: 'Passordene matcher ikke.',
      tooShort: 'Passordet må være minst 8 tegn.',
      successTitle: 'Passordet er oppdatert',
      successBody: 'Du blir sendt til innloggingen om {seconds} sekunder.',
      goToLogin: 'Gå til innlogging nå →',
      invalidTitle: 'Lenken er ugyldig',
      reasonInvalid: 'Denne reset-lenken er ikke gyldig.',
      reasonExpired: 'Denne reset-lenken er utløpt. Be om en ny.',
      reasonUsed: 'Denne reset-lenken er allerede brukt.',
      requestNew: 'Be om ny reset-lenke →',
    },
    signup: {
      eyebrow: 'Nº 02 — BLI MED I NORVIG',
      title: 'Opprett',
      titleAccent: 'konto.',
      sub: 'Registrer deg på 30 sekunder. Gratis å komme i gang.',
      submit: 'Opprett konto',
      loading: 'Oppretter konto…',
      successToast: 'Velkommen til Norvig.',
      failed: 'Registrering feilet',
      already: 'Har du allerede konto?',
      goToLogin: 'Logg inn →',
      googleHint: 'Vil du heller bruke Google? Bruk «Fortsett med Google» på innloggingssiden.',
      duplicateEmail: 'Det finnes allerede en konto med denne e-posten. Klikk «Logg inn» og prøv passordet ditt.',
      orgnrLabel: 'Institusjonens organisasjonsnummer',
      orgnrPlaceholder: '9 siffer, f.eks. 923609016',
      orgnrHint: 'Institusjonsnavnet hentes automatisk fra Brønnøysundregistrene (BRREG).',
      institutionNotice: 'Merk: Det er ikke kommunen som sådan som skal registreres, men den aktuelle institusjonen — f.eks. sykehjemmet, skolen eller barnehagen — med institusjonens eget organisasjonsnummer.',
      brregLooking: 'Slår opp i Enhetsregisteret…',
      brregCompanyLabel: 'Selskap (fra BRREG)',
      brregNotFound: 'Fant ingen organisasjon med dette nummeret. Kontroller organisasjonsnummeret.',
      brregRequired: 'Du må oppgi et gyldig organisasjonsnummer for å registrere deg som kommune.',
      switchToEmployer: 'Representerer du en kommune? Registrer kommunen her',
      switchToProfessional: 'Er du fagarbeider? Registrer deg her',
    },
  },
  hero: {
    title: { line1: 'Norge venter.', line2: 'På deg som bryr deg.' },
    subtitle:
      'Norvig kobler sykepleiere, helsefagarbeidere og annet omsorgspersonell rett til norske kommuner. Ingen mellomledd. Full oppfølging — fra første søknad til første vakt.',
    ctaPrimary: 'Registrer deg',
    ctaSecondary: 'Slik fungerer det',
    trust: ['Gratis for fagarbeidere', 'Trygt og kvalitetssikret', 'Treffsikker kobling'],
    imageAlt: 'Premium plattform for rekruttering til Norge',
    scrollHint: 'Rull for mer',
  },
  heroCinematic: {
    eyebrow: 'Nº 01 — NORVIG TALENTS',
    headline: 'Skap din nye livsvei i Norge.',
    lede:
      'Norvig er en moderne bemanningsplattform som forbinder helsepersonell og pedagoger med kommuner som verdsetter omsorg, kompetanse og pålitelighet.',
    ctaEmployers: 'For kommuner',
    ctaWorkers: 'For fagarbeidere',
    scrollHint: 'Rull videre',
    imageAlt: 'Norsk fjord ved daggry — bølger og lys over havet.',
  },
  sectors: {
    eyebrow: 'Sektorer',
    titleA: 'En plattform.',
    titleB: 'Tre sektorer.',
    sub:
      'Helse og omsorg er kjernen i Norvig — fra sykehjem og hjemmetjeneste til helsehus. I tillegg dekker vi oppvekst og utdanning, samt sesongarbeid innen frukt, bær og reiseliv. Direkte, uten mellomledd.',
    areasOne: 'område',
    areasMany: 'områder',
    explore: 'Utforsk',
    openings: 'ledige',
    openingsComingSoon: 'Kommende roller',
    ctaExploreAll: 'Utforsk alle sektorer',
  },
  journey: {
    eyebrow: 'Reisen gjennom Norge',
    titleA: 'Fra første tanke',
    titleB: 'til første dag.',
    sub:
      'Vi går veien sammen — fra første søknad til etablert hverdag i Norge. Klart, trygt og uten skjulte kostnader.',
    ctaStart: 'Start reisen din',
    steps: [
      { place: 'Hjemmefra', title: 'Match', desc: 'Lag profilen din. Vi finner stillinger som passer kompetansen.' },
      { place: 'Online', title: 'Intervju', desc: 'Vi rigger deg til intervjuet og bistår med kontrakten.' },
      { place: 'Helsedirektoratet', title: 'Godkjenning', desc: 'Vi loser deg gjennom autorisasjon og visumsøknad.' },
      { place: 'OSL · BGO · TRD', title: 'Bosetting', desc: 'Bolig, bank, språkkurs og det praktiske — vi ordner det sammen.' },
      { place: 'Hjem i Norge', title: 'Etablering', desc: 'Vi følger deg tett — også etter at du er kommet i jobb.' },
    ],
  },
  stats: {
    // Soft, documentable product facts — shown until real platform numbers
    // pass the per-metric thresholds in Stats.jsx (fetched live from
    // /api/public/platform-stats).
    items: [
      { value: '1 390+',  label: 'Helse- og omsorgsinstitusjoner kartlagt' },
      { value: '0 kr',    label: 'Gratis for fagarbeidere' },
      { value: '100 %',   label: 'BRREG-verifiserte kommuner' },
      { value: 'Direkte', label: 'Kontakt uten mellomledd' },
    ],
    live: {
      jobs: 'Aktive stillinger',
      professionals: 'Registrerte fagarbeidere',
      employers: 'Kommuner',
    },
    liveBadge: 'Sanntidstall fra plattformen — oppdatert nå',
  },
  kontakt: {
    eyebrow: 'Kontakt',
    title: 'Snakk med oss',
    titleAccent: 'direkte.',
    sub: 'Er dere en kommune eller offentlig virksomhet som vurderer Norvig? Send oss en melding — vi svarer som regel innen én virkedag.',
    form: {
      name: 'Navn',
      email: 'E-post',
      organization: 'Organisasjon (valgfritt)',
      phone: 'Telefon (valgfritt)',
      category: 'Jeg representerer',
      categories: {
        kommune: 'Kommune',
        virksomhet: 'Offentlig virksomhet',
        fagarbeider: 'Fagarbeider',
        annet: 'Annet',
      },
      message: 'Melding',
      messagePlaceholder: 'Fortell kort hva det gjelder …',
      submit: 'Send melding',
      sending: 'Sender …',
      successTitle: 'Takk for meldingen!',
      successBody: 'Vi har mottatt henvendelsen og svarer som regel innen én virkedag.',
      sendAnother: 'Send en ny melding',
      errorGeneric: 'Noe gikk galt. Prøv igjen om litt.',
      errorRate: 'For mange meldinger på kort tid — prøv igjen om et kvarter.',
    },
    aside: {
      title: 'Andre veier inn',
      items: [
        { label: 'For kommuner', desc: 'Les hvordan plattformen fungerer for dere.', href: '/for-kommuner' },
        { label: 'Prismodellen', desc: 'Åpne sektorsatser — publisert i sin helhet.', href: '/priser' },
      ],
    },
  },
  sectorPage: {
    eyebrow: 'NORVIG · SEKTOR',
    statsJobs: 'Åpne stillinger',
    statsCandidates: 'Registrerte kandidater',
    ctaCandidate: 'Registrer deg som kandidat',
    ctaEmployer: 'For kommuner',
    salaryTitle: 'Yrker og veiledende lønn',
    salarySub: 'Brutto årslønn i offentlig sektor. Faktisk lønn avhenger av utdanning, ansiennitet og arbeidssted.',
    salarySource: 'Veiledende spenn basert på offentlig lønnsstatistikk (SSB) og gjeldende tariffavtaler (KS).',
    perYear: 'kr/år',
    benefitsTitle: 'Det du kan forvente',
    teasersTitle: 'Kandidater i sektoren',
    teasersSub: 'Et anonymisert utvalg av registrerte fagarbeidere.',
    teasersEmpty: 'Ingen kandidatkort å vise ennå.',
    teaserYears: (n) => `${n} års erfaring`,
    teaserAvailable: 'Tilgjengelig',
    teaserCta: 'Registrer kommune for å se fulle profiler',
    share: 'Kopier delingslenke',
    shared: 'Lenke kopiert',
  },
  kommunePage: {
    nav: { login: 'Logg inn', signup: 'Registrer institusjonen' },
    active: {
      eyebrow: 'Aktive på Norvig',
      title: 'Kommuner som allerede',
      titleAccent: 'rekrutterer direkte.',
      body: 'Oversikten er datadrevet og oppdateres automatisk når nye stillinger publiseres på Norvig.',
      jobOne: 'åpen stilling',
      jobMany: 'åpne stillinger',
      empty: 'De første kommunene er på vei inn. Bli blant de første —',
      emptyCta: 'registrer kommunen din gratis',
    },
    hero: {
      eyebrow: 'For norske kommuner',
      title: 'Bemann helse og omsorg',
      titleAccent: 'uten mellomledd.',
      sub: 'Norvig kobler kommunen direkte til kvalifisert helsepersonell — sykepleiere, helsefagarbeidere og vernepleiere — med verifiserte profiler, dokumenthåndtering og en åpen prismodell. Gratis å komme i gang.',
      cta: 'Registrer institusjonen',
      pricingLink: 'Se prismodellen',
      demoCta: 'Book en demo',
    },
    demo: {
      eyebrow: 'Book en demo',
      title: 'Se Norvig i praksis —',
      titleAccent: 'velg en tid som passer.',
      body: 'En 30-minutters videosamtale der vi viser hvordan kommunen kan finne, vurdere og ansette helsepersonell direkte. Uforpliktende og gratis.',
      dateLabel: 'Velg dato',
      slotLabel: 'Velg tidspunkt',
      slotHint: 'Alle tider er norsk tid. Hverdager 09–15.',
      pickDateFirst: 'Velg en dato i kalenderen først.',
      allTaken: 'Ingen ledige tider denne dagen — velg en annen dato.',
      form: {
        name: 'Navn',
        email: 'E-post',
        organization: 'Kommune',
        phone: 'Telefon (valgfritt)',
        note: 'Hva ønsker dere å se? (valgfritt)',
      },
      submit: 'Book demo-samtale',
      submitting: 'Booker …',
      successTitle: 'Demo booket!',
      successBody: 'Vi har mottatt bookingen for {date} kl. {slot}. Du får en bekreftelse på e-post med kalenderinvitasjon (.ics) og møtelenken — samtalen er klar, uten mer styr.',
      meetingLinkLabel: 'Møtelenke:',
      addToCalendar: 'Legg til i kalenderen',
      newBooking: 'Book en ny tid',
      error: 'Noe gikk galt. Prøv igjen — eller skriv til hei@norvig.no.',
      slotTaken: 'Tidspunktet ble nettopp tatt. Velg et annet.',
    },
    valuesEyebrow: 'Hvorfor Norvig',
    values: [
      { title: 'Direkte kontakt', body: 'Dere snakker med kandidatene selv — uten byrå eller mellomledd. Meldinger, dokumenter og avtaler skjer på ett sted.' },
      { title: 'Verifiserte profiler', body: 'Kandidater kan laste opp CV, autorisasjon og vitnemål. Kommuner BRREG-verifiseres mot Enhetsregisteret ved onboarding.' },
      { title: 'Internasjonal talentpool', body: 'Sykepleiere, helsefagarbeidere og pedagoger fra EØS og resten av verden — klare for norske kommuner.' },
      { title: 'Åpen prismodell', body: 'Gratis å registrere seg og søke. Sektorsatser ved ansettelse er publisert åpent — ingen skjulte gebyrer eller bindingstid.' },
    ],
    calc: {
      sectionEyebrow: 'Kostnadsbildet',
      sectionTitle: 'Se hva mellomleddet',
      sectionTitleAccent: 'faktisk koster.',
      sectionBody: 'Tradisjonell byrårekruttering prises gjerne som en andel av årslønnen. Med Norvig søker dere gratis, snakker direkte med kandidatene, og betaler først ved faktisk ansettelse — etter åpne sektorsatser.',
      bullets: ['Gratis registrering og kandidatsøk', 'Ingen bindingstid eller abonnement', 'Publiserte satser per sektor'],
      eyebrow: 'Eksempelberegning',
      title: 'Hva koster byråpåslaget?',
      sub: 'Rekrutteringsbyråer tar typisk 15–25 % av årslønn per ansettelse. Regn ut hva det utgjør for dere — og sammenlign med Norvigs publiserte sektorsatser.',
      countLabel: 'Antall ansettelser',
      salaryLabel: 'Årslønn per stilling',
      resultLabel: 'Typisk byråkostnad (15–25 % av årslønn)',
      disclaimer: 'Eksempelberegning — ikke et pristilbud. Norvigs faktiske satser per sektor er publisert åpent på prissiden, og registrering og kandidatsøk er gratis.',
    },
    processEyebrow: 'Slik fungerer det',
    steps: [
      { title: 'Registrer kommunen', body: 'Opprett konto og verifiser organisasjonsnummeret mot BRREG.' },
      { title: 'Legg ut stillinger', body: 'Beskriv behovet — plattformen matcher mot relevante kandidater i deres sektor.' },
      { title: 'Vurder kandidater', body: 'Se profiler, CV og dokumenter. AI-assistert matching hjelper dere å prioritere.' },
      { title: 'Ansett direkte', body: 'Avtal intervju og ansettelse direkte med kandidaten. Vi støtter prosessen hele veien.' },
    ],
    cta: {
      title: 'Klar til å møte',
      titleAccent: 'kandidatene direkte?',
      body: 'Opprett en kommunekonto på noen minutter. Har dere spørsmål først, svarer vi gjerne.',
      signup: 'Registrer institusjonen',
      contact: 'Kontakt oss',
    },
  },
  norgeDream: {
    eyebrow: 'Drømmen om Norge',
    titleA: 'Mer enn en jobb.',
    titleB: 'Et liv.',
    sub:
      'Norge er kanskje ikke det første du tenker på. Men de som kommer hit, forteller den samme historien: et land der hverdagen er menneskelig — og der det fortsatt er plass til å puste.',
    imageAlt: 'Bygdenorge — røde hus ved fjorden',
    sectionNumber: 'Nº 02',
    sectionTag: 'Det norske livet',
    galleryTagline: 'Et samfunn der fjellet er nabo og lyset varer hele sommerkvelden.',
    gallery: [
      { id: 'landscape-nature',  caption: 'Landskap & natur',        src: '/hero/landscape-nature.webp',  alt: 'Norsk landskap og natur' },
      { id: 'idyllic-community', caption: 'Idylliske lokalsamfunn',  src: '/hero/idyllic-community.webp', alt: 'Idylliske lokalsamfunn' },
      { id: 'picturesque-town',  caption: 'Pittoreske bymiljø',      src: '/hero/picturesque-town.webp',  alt: 'Pittoreske norske bymiljø' },
      { id: 'sport-leisure',     caption: 'Sport & fritid',          src: '/hero/sport-leisure.webp',     alt: 'Sport og fritid i Norge' },
      { id: 'culture-life',      caption: 'Kulinarisk',              src: '/hero/culture-life.webp',      alt: 'Nordisk gastronomi' },
      { id: 'fjord-village',     caption: 'Bygdenorge',              src: 'https://images.unsplash.com/photo-1564739749969-e85beb154a32?auto=format&fit=crop&w=1600&q=85', alt: 'Bygdenorge — røde hus ved fjorden' },
    ],
    norgeITall: {
      eyebrow: 'Norge i tall',
      items: [
        { n: '103 000', u: 'km', l: 'kystlinje' },
        { n: '1 190',   u: '',   l: 'fjorder' },
        { n: '240 000', u: '',   l: 'innsjøer' },
        { n: '5,6',     u: 'mill', l: 'innbyggere' },
      ],
    },
    hverdagen: {
      eyebrow: 'Hverdagen',
      title: 'Et liv her betyr noe konkret.',
      fakta: [
        { n: '49',     u: 'uker',  l: 'foreldrepermisjon', d: 'med full lønn — for begge.' },
        { n: '25',     u: 'dager', l: 'ferie i året',      d: 'minst. Mange har mer.' },
        { n: '7,5',    u: 't / dag', l: 'arbeidstid',      d: 'og hjem til middag.' },
        { n: 'Topp 10', u: '',      l: 'lykkeligste land',  d: 'år etter år, ifølge FNs World Happiness Report.' },
      ],
    },
    pullquote:
      'Her har du rett på fri med full lønn når barna er syke. Etter jobb er fjellet, sjøen eller skogen aldri langt unna. I Norge møter du et samfunn bygd på tillit og fellesskap.',
    quoteAuthor: '— Hverdagen i Norge',
    lightbox: {
      openHint: 'Klikk for å forstørre',
      openLabel: 'Åpne {caption} i fullskjerm',
      close: 'Lukk fullskjermbilde',
      prev: 'Forrige bilde',
      next: 'Neste bilde',
      share: 'Del bildet',
      shareTitle: 'Norvig — NorgeDream',
      shareText: 'Se dette bildet fra Norvigs NorgeDream-galleri',
      shareCopied: 'Lenke kopiert',
      shareFailed: 'Kunne ikke dele',
    },
  },
  tenders: {
    nav: 'Anbud',
    public: {
      pageEyebrow: 'NORVIG · ANBUD',
      title: 'Anbud Norvig overvåker',
      italicSuffix: 'rekruttering, helse og utdanning.',
      lede: 'Vi følger med på relevante offentlige anbud på Doffin innen rekruttering, helse og utdanning. Her ser du hva som er aktivt akkurat nå.',
      cpvHeading: 'Vi sporer disse kategoriene',
      filterLabel: 'Sektor',
      filterAll: 'Alle',
      sectorHelse: 'Helse',
      sectorUtdanning: 'Utdanning',
      sectorGenerell: 'Generell rekruttering',
      sortLabel: 'Sortér',
      sortNewest: 'Nyeste først',
      sortDeadline: 'Nærmeste frist',
      cardPublished: 'Publisert',
      cardDeadline: 'Frist',
      cardDeadlineSoon: 'Frist om {n} dager',
      cardDeadlinePassed: 'Frist passert',
      cardValue: 'Est. verdi',
      cardViewDoffin: 'Se hos Doffin',
      empty: 'Ingen aktive anbud akkurat nå. Vi sjekker daglig — kom gjerne tilbake.',
      lastFetched: 'Datakilde: Doffin · sist oppdatert {dt}',
      mercellHeading: 'Andre kilder vi følger',
      mercellBody: 'I tillegg til Doffin følger vi Mercell og TED (Tenders Electronic Daily) for europeiske anbud. Du kan søke direkte:',
      mercellLink: 'Søk på Mercell',
      tedLink: 'Søk på TED Europa',
      pagination: '{from}–{to} av {total}',
    },
    status: {
      new: 'Ny',
      reviewed: 'Vurdert',
      interested: 'Interessant',
      bid_submitted: 'Tilbud sendt',
      won: 'Vunnet',
      lost: 'Tapt',
      not_relevant: 'Ikke relevant',
      archived: 'Arkivert',
    },
    sector: {
      helse: 'Helse',
      utdanning: 'Utdanning',
      generell: 'Generell',
    },
    cta: {
      interested: 'Norvig følger denne saken — er du interessert i samarbeid?',
      bidSubmitted: 'Norvig har sendt inn tilbud — ta kontakt for dialog',
      contactButton: 'Ta kontakt',
      highValueBadge: 'Høyverdig',
    },
    inquiry: {
      modal: {
        eyebrow: 'KONTAKT NORVIG',
        title: 'Kontakt oss om dette anbudet',
        subtitle: 'Vi tar kontakt innen 24 timer.',
        nameLabel: 'Navn',
        companyLabel: 'Selskap',
        emailLabel: 'E-post',
        phoneLabel: 'Telefon (valgfri)',
        messageLabel: 'Melding',
        defaultMessage: "Jeg er interessert i Norvigs arbeid på anbudet '{title}' (Doffin-ref: {ref}). Ta kontakt for en samtale.",
        send: 'Send henvendelse',
        sending: 'Sender …',
        cancel: 'Avbryt',
        successTitle: 'Takk!',
        successBody: 'Vi tar kontakt innen 24 timer.',
        errorGeneric: 'Noe gikk galt. Prøv igjen.',
        errorRate: 'For mange henvendelser fra denne IP-en. Prøv igjen om en time.',
        emailInvalid: 'Vennligst skriv en gyldig e-postadresse.',
        required: 'Påkrevd felt',
      },
    },
  },
  documents: {
    eyebrow: 'DOKUMENTER',
    cvHeading: 'CV',
    cvHelper: 'PDF, maks 10 MB',
    cvUploadCta: 'Slipp PDF her eller klikk for å velge',
    cvPreview: 'Forhåndsvis',
    cvDelete: 'Slett CV',
    cvBadge: 'CV',
    certHeading: 'Sertifikater',
    certCount: '{n} av {max}',
    certEmpty: 'Ingen sertifikater ennå.',
    certAddCta: 'Legg til sertifikat',
    certAddModalTitle: 'Nytt sertifikat',
    certTitleLabel: 'Tittel',
    certTitlePlaceholder: 'Eks. Sykepleier-autorisasjon',
    certFileLabel: 'PDF-fil',
    certAddSubmit: 'Lagre sertifikat',
    certUploading: 'Laster opp …',
    certPreview: 'Forhåndsvis',
    certDelete: 'Slett',
    certFull: 'Du har nådd grensen på {max} sertifikater. Slett en for å legge til ny.',
    cancelLabel: 'Avbryt',
    inlinePreview: {
      heading: 'Forhåndsvisning',
      loading: 'Laster forhåndsvisning …',
      error: 'Kunne ikke laste forhåndsvisningen. Prøv å laste ned i stedet.',
      unavailableDocx: 'Forhåndsvisning er ikke tilgjengelig for DOCX-filer. Last ned for å åpne dokumentet.',
      close: 'Lukk forhåndsvisning',
      download: 'Last ned',
    },
    pdf: {
      close: 'Lukk',
      download: 'Last ned',
      prev: 'Forrige side',
      next: 'Neste side',
      page: 'Side',
      of: 'av',
      loading: 'Laster …',
      error: 'Kunne ikke laste PDF.',
    },
    candidateCardCvBadge: 'CV',
    candidateCardCertBadge: '{n} sertifikat',
    candidateCardCertBadgePlural: '{n} sertifikater',
    employerOnlyMessage: 'Krever kommunekonto',
    proDocs: {
      eyebrow: 'MINE DOKUMENTER',
      heading: 'Mine dokumenter',
      subtitle: 'Last opp CV, sertifikater og andre relevante dokumenter (PDF, DOCX, JPEG, PNG — maks 10 MB per fil, 10 totalt).',
      uploadCta: 'Last opp nytt',
      empty: 'Ingen dokumenter ennå. Last opp CV-en din for å komme i gang.',
      counter: '{n} av {max} dokumenter',
      categories: {
        cv: 'CV',
        sertifikat: 'Sertifikat',
        vitnemal: 'Vitnemål',
        anbefaling: 'Anbefalingsbrev',
        annet: 'Annet',
      },
      actions: {
        preview: 'Forhåndsvis',
        download: 'Last ned',
        edit: 'Rediger',
        delete: 'Slett',
      },
      deleteConfirm: 'Er du sikker på at du vil slette dette dokumentet?',
      upload: {
        modalTitle: 'Last opp dokument',
        modalSubtitle: 'Tillatt: PDF, DOCX, JPEG, PNG — maks 10 MB.',
        dropzone: 'Slipp filen her',
        dropzoneSub: 'eller klikk for å velge',
        selectFile: 'Velg fil',
        chosenFile: 'Valgt:',
        categoryLabel: 'Kategori',
        categoryPlaceholder: 'Velg kategori …',
        customLabelLabel: 'Beskrivelse (kort)',
        customLabelHelp: 'Maks 60 tegn',
        descriptionLabel: 'Notat (valgfritt)',
        descriptionHelp: 'Maks 280 tegn — synlig for kommuner som har tilgang',
        confirmButton: 'Last opp',
        uploading: 'Laster opp …',
        cancel: 'Avbryt',
        errors: {
          tooLarge: 'Filen er for stor. Maks 10 MB.',
          invalidType: 'Ugyldig filtype. Tillatt: PDF, DOCX, JPEG, PNG.',
          magicMismatch: 'Filinnholdet matcher ikke filtypen.',
          limitReached: 'Du har nådd grensen på 10 aktive dokumenter.',
          rateLimited: 'Du har nådd maks antall opplastinger i dag (10). Prøv igjen i morgen.',
          generic: 'Opplasting feilet. Prøv igjen.',
          emptyFile: 'Tom fil.',
        },
        success: 'Dokumentet er lastet opp.',
      },
      edit: {
        modalTitle: 'Rediger dokument',
        saveButton: 'Lagre endringer',
        saved: 'Endringer lagret.',
      },
      employerView: {
        eyebrow: 'KANDIDATENS DOKUMENTER',
        heading: 'Dokumenter',
        empty: 'Kandidaten har ikke delt noen dokumenter ennå.',
        accessHint: 'Du har tilgang fordi dere har samhandlet (lagret kandidat, samtale eller melding sendt).',
        download: 'Last ned',
        requestAccessCta: 'Be om CV-tilgang',
        requestAccessHint: 'Du har ikke tilgang til kandidatens dokumenter ennå. Kandidaten varsles med en melding når du ber om tilgang.',
        requestAccessFailed: 'Kunne ikke be om tilgang. Prøv igjen.',
      },
      preferences: {
        eyebrow: 'VARSLINGER',
        heading: 'Varslinger',
        subtitle: 'Få beskjed når relevante ting skjer med profilen din.',
        documentAccess: 'Send meg e-post når en kommune ser dokumentene mine',
        documentAccessHint: 'Maks én e-post per kommune per døgn. Vi røper aldri navnet til kommunen — kun sektoren.',
        saved: 'Lagret',
        saving: 'Lagrer …',
      },
    },
  },
  features: {
    eyebrow: 'Hvorfor Norvig',
    titleA: 'Bygget på presisjon.',
    titleB: 'Drevet av mennesker.',
    items: [
      { title: 'Treffsikker kobling',      desc: 'Norvig vekter erfaring, sertifisering, språk og preferanser. Rett kandidat til rett stilling — på sekunder.' },
      { title: 'Jobb der du trengs mest',  desc: 'Sykehjem, hjemmetjeneste, helsehus og omsorgsboliger — samt skoler og barnehager — over hele landet.' },
      { title: 'Direkte kontakt',          desc: 'Snakk med kommunen selv. Uten mellomledd. Uten gebyrer.' },
      { title: 'Bli kjent med Norge',      desc: 'Egne profiler om kommuner, bolig, kultur og hverdag.' },
      { title: 'Trygt og kvalitetssikret', desc: 'Vi sjekker alle. All data ligger trygt. Helt etter GDPR.' },
    ],
  },
  howItWorks: {
    eyebrow: 'Slik fungerer det',
    titleA: 'Enkelt å starte.',
    titleB: 'Trygt å fullføre.',
    cols: [
      {
        kind: 'pro',
        title: 'For deg som søker jobb',
        cta: 'Kom i gang gratis',
        steps: [
          { title: 'Lag profilen', desc: 'Fortell oss om kompetanse, erfaring og hva du ser etter.' },
          { title: 'Få treff',     desc: 'Få stillinger som passer kompetansen din — ikke bare nøkkelord.' },
          { title: 'Søk og start', desc: 'Send søknaden — vi følger deg hele veien til Norge.' },
        ],
      },
      {
        kind: 'emp',
        title: 'For deg som ansetter',
        cta: 'Start rekruttering',
        steps: [
          { title: 'Opprett konto',     desc: 'Registrer kommunen eller virksomheten — gratis å komme i gang.' },
          { title: 'Legg ut stillingen', desc: 'Nå hundrevis av kvalifiserte søkere på kort tid.' },
          { title: 'Velg kandidaten',   desc: 'Få treffsikre kandidater og snakk med dem direkte.' },
        ],
      },
    ],
  },
  whyNorway: {
    eyebrow: 'Hvorfor Norge',
    titleA: 'Et land verdt',
    titleB: 'å bli i.',
    sub: 'Skandinavisk livskvalitet, naturskjønne omgivelser og et helsevesen i verdensklasse. Et liv mange andre bare drømmer om.',
    items: [
      { title: 'Lønn som monner',    desc: 'Tariff og gode arbeidsvilkår — gjennom hele yrkeslivet.' },
      { title: 'Balanse i hverdagen', desc: 'Sjenerøse ferier, rom for familie og tid til å leve.' },
      { title: 'Trygghet på alvor',  desc: 'Helsevesen og velferd som favner deg fra dag én.' },
      { title: 'Et åpent samfunn',   desc: 'Inkluderende, internasjonalt og likeverdig arbeidsliv.' },
    ],
  },
  success: {
    eyebrow: 'Historie',
    irrisHeadline: '«Det er mulig å begynne på nytt. Det er mulig å finne sin plass.»',
    irrisBody1:
      'Irris Hollanes Lua kom til Norge fra Filippinene med ett visum og ingen norske ord. I dag jobber hun som sykepleier ved Helsefonna i Haugesund — etter å ha lært språket, fått utdanningen godkjent og bygd seg opp fra helsefagarbeider i Finnmark.',
    irrisBody2Pre: 'Veien gikk gjennom lange reiser, krevende prøver og søvnløse netter. ',
    irrisBody2Bold: 'Men hun ga ikke opp.',
    irrisBody2Post:
      ' Steg for steg bygget hun seg opp — fra Finnmark, til Vindafjord, til Haugesund. I dag er hun aktiv i flerkulturelt arbeid og integrering.',
    irrisBullets: [
      'Fra besøksvisum til autorisert sykepleier — uten snarveier',
      'Norskprøver, godkjenning fra Helsedirektoratet, fagopplaering',
      'I dag aktiv i flerkulturelt arbeid og integrering',
    ],
    irrisCardEyebrow: 'Fra Filippinene til Norge',
    irrisCardName: 'Irris Hollanes Lua',
    irrisCardRole: 'Sykepleier · Helsefonna, Haugesund',
    irrisPortraitAlt: 'Irris Hollanes Lua — sykepleier ved Helsefonna',
    ctaRead: 'Les hele historien',
    ctaJoin: 'Bli neste historie',
    moreEyebrow: 'Flere historier',
    moreTitle: 'Flere som har funnet sin plass.',
    moreSeeAll: 'Se alle 6 historier',
    cardCtaBadge: 'Din tur',
    cardCtaTitle: 'Den neste historien kan være din.',
    cardCtaSub: 'Norvig hjelper deg fra første søknad til første arbeidsdag — og lenge etter.',
    cardCtaButton: 'Start din reise',
  },
  testimonials: {
    eyebrow: 'Stemmer',
    titleA: 'Fra fagarbeidere',
    titleB: 'og kommuner.',
    items: [
      {
        name: 'Lars Andersen',
        role: 'HR-leder',
        org: 'Bergen Kommune',
        text: 'Vi fant perfekte kandidater på bare noen uker. Matchingen sparer oss for masse tid.',
      },
      {
        name: 'Klaudia Pawlowski',
        role: 'Sykepleier',
        org: 'Stavanger',
        text: 'Fra Polen til Norge på 8 uker. Norvig gjorde papirarbeidet enklere enn jeg trodde var mulig.',
      },
      {
        name: 'Jens Eriksen',
        role: 'Avdelingsleder, sykehjem',
        org: 'Tromsø',
        text: 'Vi har ansatt fire stykker via Norvig det siste året. Kvaliteten på kandidatene er utrolig høy.',
      },
    ],
  },
  faq: {
    eyebrow: 'Spørsmål',
    titleA: 'Ofte stilte',
    titleB: 'spørsmål.',
    sub: 'Det meste finner du svar på her. Lurer du fortsatt på noe? Si i fra — vi svarer som regel innen samme dag.',
    items: [
      { q: 'Koster Norvig noe?',                a: 'For fagarbeidere er Norvig helt gratis. Kommuner registrerer seg og søker gratis, og betaler først en åpen sektorsats ved faktisk ansettelse — satsene er publisert på prissiden. Ingen abonnement eller skjulte kostnader.' },
      { q: 'Hvordan fungerer matchingen?',      a: 'Vi vekter erfaring, kompetanse, språk og hva du selv ønsker — og kobler deg sammen med stillingene som faktisk passer.' },
      { q: 'Hvilke stillinger finner jeg?',     a: 'Først og fremst helse og omsorg: sykepleiere, helsefagarbeidere, vernepleiere og flere — på sykehjem, i hjemmetjeneste og helsehus. I tillegg oppvekst og utdanning. Over hele landet.' },
      { q: 'Hva skjer med opplysningene mine?', a: 'Personvern står i sentrum. All data ligger trygt og kryptert. Vi følger GDPR og norske personvernregler — strengt.' },
      { q: 'Kan jeg søke på flere stillinger?', a: 'Ja. Søk på så mange du vil og følg statusen på alle søknadene fra ditt eget dashbord.' },
      { q: 'Hjelper dere med å flytte?',        a: 'Ja. Du får tilgang til oversikt over kommuner, bolig, transport og hverdag — og menneskelig oppfølging hele veien.' },
    ],
  },
  finalCta: {
    titleA: 'Klar for et',
    titleB: 'nytt kapittel?',
    sub:
      'Bli med — sammen med tusener av fagarbeidere og kommuner som allerede har funnet hverandre på Norvig. Det tar mindre enn ett minutt.',
    ctaPrimary: 'Registrer deg gratis',
    ctaSecondary: 'Se ledige stillinger',
    footnote: 'Ingen skjulte kostnader · Avbryt når som helst · GDPR-kompatibelt',
  },
  footer: {
    banner: {
      eyebrow: 'Norvig — Norges rekrutteringsplattform',
      titleA: 'Norges plattform for direkte',
      titleB: 'kobling mellom talent og kommune.',
      sub: 'Bemanning til helse & omsorg — og oppvekst & utdanning. Fra første samtale til signert kontrakt — uten mellomledd og uten gebyrer.',
    },
    hq: {
      eyebrow: 'Norvig HQ',
      location: 'Norge',
    },
    brandBlurb: 'Norvig kobler helsepersonell og pedagoger direkte med norske kommuner — uten mellomledd. Fra sykehjem til skole. Hele Norge.',
    // ─── Facelift Fase 1 — editorial manifest (2 linjer, kort) ────────────
    manifest: 'Bemanningsplattformen som forbinder verdens helsepersonell med norske kommuner som trenger dem.',
    // ─── Facelift Fase 1 — editorial column groups ───────────────────────
    editorialCols: [
      {
        title: 'For fagarbeidere',
        links: [
          { label: 'Registrer deg',     href: '/signup' },
          { label: 'Utforsk stillinger', href: '/jobs' },
          { label: 'Sektorer',          href: '/#sektorer', scroll: 'sektorer' },
          { label: 'Slik fungerer det', href: '/#how-it-works', scroll: 'how-it-works' },
          { label: 'Ressurser',         href: '/horisont' },
        ],
      },
      {
        title: 'For kommuner',
        links: [
          { label: 'Kom i gang',        href: '/for-kommuner' },
          { label: 'Publiser stilling', href: '/signup' },
          { label: 'Priser',            href: '/priser' },
          { label: 'Anbud',             href: '/anbud' },
          { label: 'Case',              href: '/historier' },
        ],
      },
      {
        title: 'Selskap',
        links: [
          { label: 'Om oss',    href: '/om-oss' },
          { label: 'Om Norge',  href: '/om-norge' },
          { label: 'Kommuneoversikt', href: '/kommuneoversikt' },
          { label: 'Nyhetsbrev', href: '/nyhetsbrev' },
          { label: 'Investors', href: '/investors' },
          { label: 'Kontakt',   href: '/kontakt' },
        ],
      },
      {
        title: 'Juridisk',
        links: [
          { label: 'Vilkår',      href: '/vilkar/fagarbeider' },
          { label: 'Personvern',  href: '/privacy' },
          { label: 'Cookies',     href: '/privacy#cookies' },
        ],
      },
    ],
    // ─── Bunn-bar ────────────────────────────────────────────────────────
    bottomCopyright: '© 2026 Norvig',
    rightsReserved: 'Alle rettigheter forbeholdt',
    cols: [],
    stats: [
      { n: '5,6M', l: 'Innbyggere' },
      { n: '357',  l: 'Kommuner' },
      { n: '2',    l: 'Sektorer' },
      { n: '1',    l: 'Plattform' },
    ],
    copyright: '© 2026 Norvig AS · Org. 931 928 732 · Norge',
    tagline: 'Bygd med omtanke i Norge.',
    miljofyrtarn: {
      label: 'Sertifisert Miljøfyrtårn',
      cta: 'Les mer',
      alt: 'Miljøfyrtårn — sertifisert virksomhet',
      ariaLabel: 'Norvig er sertifisert Miljøfyrtårn — les mer (åpner i ny fane)',
    },
    miniCopyright: '© 2026 — Norges plattform for direkte kobling.',
    miniLinks: [
      { label: 'Hjem', href: '/' },
      { label: 'Historier', href: '/historier' },
      { label: 'Sektorer', href: '/#sektorer', scroll: 'sektorer' },
      { label: 'Om Norge', href: '/om-norge' },
      { label: 'Om oss', href: '/om-oss' },
    ],
  },
  omNorge: {
    eyebrow: 'Et liv i Norge',
    titleA: 'Et land verdt',
    titleB: 'å bli i.',
    sub: 'Norge er mer enn en arbeidsplass. Det er trygghet, balanse og frihet — bygget på tillit. Et samfunn der hverdagen er menneskelig, og hvor det fortsatt er plass til å puste.',
    imageAlt: 'Kristiansand havn ved blå time',
    factsEyebrow: 'Hverdagen',
    factsTitle: 'Fire ting som gjør Norge annerledes.',
    facts: [
      { label: 'Lønn',     title: 'Tariff fra dag én',   text: 'Norske tariffavtaler gir forutsigbar lønn. Overtid betales. Tilliten til kommunens oppgjør er innebygd i systemet.' },
      { label: 'Balanse',  title: '7,5 timer per dag',   text: 'Standardarbeidsdagen er 7,5 timer. 25 dagers ferie. 49 ukers betalt foreldrepermisjon. Familietid er ikke et privilegium — det er normen.' },
      { label: 'Trygghet', title: 'Blant verdens tryggeste', text: 'Norge er rangert blant verdens tryggeste land. Lav kriminalitet. Pålitelige offentlige tjenester. Et helsevesen som virker.' },
      { label: 'Åpenhet',  title: 'Tillit som standard', text: 'Lederen tar bussen. Statsministeren handler selv. Hierarkier er flate, kommunikasjonen direkte. Tillit er en samfunnskontrakt.' },
    ],
    statsEyebrow: 'Norge i tall',
    statsTitle: 'Tallene som forteller hverdagen.',
    stats: [
      { v: '49 uker',  l: 'Foreldrepermisjon, betalt' },
      { v: '25 dager', l: 'Ferie, lovfestet' },
      { v: '7,5 t/dag', l: 'Standardarbeidsdag' },
      { v: 'Topp 10',  l: 'Tryggeste land i verden' },
    ],
    quote: 'Solen går ikke ned. Den hviler bare en stund — som en pause midt i sommeren.',
    quoteAuthor: '— Hverdagen i Norge',
    ctaTitle: 'Klar for et nytt kapittel?',
    ctaSub: 'Norvig kobler dyktige fagarbeidere rett til norske kommuner. Ingen mellomledd. Full oppfølging, fra første samtale til etablering.',
    ctaPrimary: 'Registrer deg',
    ctaSecondary: 'Les historier',
  },
  omOss: {
    eyebrow: 'Mennesker bak Norvig',
    titleA: 'Bygget av folk som',
    titleB: 'kjenner reisen.',
    sub: 'Norvig drives av et norsk team med erfaring fra rekruttering, integrering og næringsliv. Vi er overbevist om at fagarbeidere fortjener direkte kontakt — og at kommuner fortjener kvalitet uten mellomledd. Sammen bygger vi en plattform som gjør det enklere å finne hverandre.',
    teamEyebrow: 'Teamet',
    teamTitle: 'Folkene bak.',
    team: [
      // MOVED to DB: `team_portraits` collection. Consumed via
      // usePublicTeamPortraits() → /api/team-portraits. Edit at runtime
      // through /admin/team-portraits UI. Fallback: config/team-portraits.js.
    ],
    companyEyebrow: 'En reise gjennom helsevesenet — Fra Albania til Norge',
    partnership: {
      heading: 'Veien til Norvig.',
      lede: 'En reise gjennom helsevesenet — fra Shkodër til Hardanger — som ble grunnlaget for Norvig.',
      kastriot: {
        name: 'Kastriot Prenga',
        location: 'Hardanger, Norge',
        photoAlt: 'Kastriot Prenga, gründer av Norvig',
      },
      quote: {
        text: 'Vi bygger ikke bare en plattform. Vi bygger en bedre måte å koble mennesker til arbeid.',
        attribution: '— Kastriot Prenga',
      },
    },
    career: {
      eyebrow: 'KARRIERE',
      heading: 'En reise gjennom helsevesenet — fra Shkodër i Albania til Hardanger i Norge — som ble grunnlaget for Norvig.',
      sub: 'Atten år gjennom helsevesenet, ledelse og fagpolitikk — fra Shkodër til Hardanger.',
      periods: [
        {
          label: 'Albania — utdannelse og ledelse',
          years: '2007–2011',
          entries: [
            { year: '2007', icon: 'GraduationCap', text: 'Utdannet sykepleier ved Universitetet i Shkodër, Albania (21 år gammel).' },
            { year: '2007–2009', icon: 'HeartHandshake', text: 'Koordinator og tolk for italienske Caritas i Vau-Dejes, Albania.' },
            { year: '2008–2009', icon: 'BookOpen', text: 'Studier i juss (ett år).' },
            { year: '2009', icon: 'Stethoscope', text: 'Ansatt som sykepleier ved et helsesenter i Albania med ansvar innen legekontor, helsestasjon og fysioterapitjenester. Ansvar for drift, økonomi og personal.' },
            { year: '2010', icon: 'Users', text: 'Utnevnt til oversykepleier/avdelingsleder, den yngste i en slik lederrolle ved helsesenteret i Helse-Nord Albania.' },
            { year: '2011', icon: 'Briefcase', text: 'Konstituert direktør (virksomhetsleder) ved helsesenteret etter utnevnelse fra regional helsedirektør i Nord-Albania. Hatt denne rollen i et halvt år.' },
            { year: 'Des. 2011', icon: 'Plane', text: 'Flyttet til Norge for å bygge videre på karrieren innen helse og ledelse.' },
          ],
        },
        {
          label: 'Norge — klinisk karriere',
          years: '2012–2017',
          entries: [
            { year: '2012', icon: 'HeartPulse', text: 'Startet yrkeskarrieren i Norge som helsefagarbeider i kommunehelsetjenesten i Hardanger.' },
            { year: '2013', icon: 'Award', text: 'Oppnådde norsk autorisasjon som sykepleier og tiltrådte som sykepleier i kommunen.' },
            { year: '2013–2017', icon: 'TrendingUp', text: 'Gjennomførte en rekke kurs og utdanning innen demensomsorg, laboratoriearbeid, lovverk og kvalitets- og beredskapsarbeid.' },
          ],
        },
        {
          label: 'Tillitsvalgt og ledelse',
          years: '2017–2023',
          entries: [
            { year: '2017', icon: 'Handshake', text: 'Valgt som hovedtillitsvalgt for Norsk Sykepleierforbund (NSF) med ansvar for lønnsforhandlinger, turnusordninger, avtaleverk og partsamarbeid.' },
            { year: '2019', icon: 'Vote', text: 'Valgt som delegat til NSFs landsmøte. Fremmet tre saker, hvorav to ble vedtatt med flertall.' },
            { year: '2019–2023', icon: 'UserCog', text: 'Valgt inn i fylkesstyret i NSF Vestland og deltok aktivt i organisasjonsutvikling og helsepolitiske spørsmål.' },
            { year: '2019–2020', icon: 'Building2', text: 'Deltok i flere arbeidsgrupper knyttet til kommunesammenslåingsreformen og samarbeidet tett med politikere, administrasjon og fagmiljøer.' },
            { year: '2020', icon: 'GraduationCap', text: 'Fullførte videreutdanning innen helsefaglig ledelse og kompetanseutvikling.' },
            { year: '2020', icon: 'ClipboardList', text: 'Fagleder i samordnet helsetjeneste i kommunen med ansvar for fagutvikling, kvalitet og tjenestekoordinering.' },
          ],
        },
        {
          label: 'Gründer',
          years: '2023–',
          entries: [
            { year: '2023', icon: 'Rocket', text: 'Grunnla et selskap med mål om å bidra til å løse mangelen på helsepersonell gjennom rekruttering til faste stillinger, systemforståelse og innovative løsninger basert på erfaring fra helse- og forvaltningssektoren.' },
            { year: '2026', icon: 'Sparkles', text: 'Leder utviklingen av et tverrfaglig konsept innen rekruttering og kompetanseforsyning, i samarbeid med fagpersoner innen helse, organisasjonsutvikling, økonomi og kunstig intelligens.' },
          ],
        },
      ],
    },
    founderJourney: {
      attribution: '— KASTRIOT PRENGA',
      paragraphs: [
        'Med en bakgrunn innen helsevesenet både i Albania og Norge, er jeg godt rustet til å bidra til løsninger som både gagner helsepersonell og oppdragsgivere.',
        'Etter at Kastriot flyttet til Norge, har han jobbet som helsefagarbeider, sykepleier og fagleder på tvers av sykehus, sykehjem og hjemmesykepleie. Den brede erfaringen har gitt ham et helhetlig perspektiv på helsevesenets utfordringer og behov, og har gjort ham i stand til å identifisere hva som er viktig for både kommuner og ansatte.',
        'Som hovedtillitsvalgt og fylkesstyrerepresentant i Norsk Sykepleierforbund Vestland har Kastriot kjempet for bedre arbeidsvilkår, helsefremmende turnuser og konkurransedyktig lønn. Han har sett på nært hold hvordan helsepersonell kan føle seg overbelastet og undervurdert, og er derfor dedikert til å finne løsninger som både møter deres behov og de økonomiske utfordringene som helseforetak og kommuner står overfor.',
        'Gjennom sin erfaring med vikarbyråer har han fått en grundig forståelse for hvordan man kan sikre tilfredshet og engasjement både hos helsepersonell og hos oppdragsgivere.',
        'Nå er Kastriot fokusert på å bruke erfaringen til å bygge et rekrutterings- og bemanningsbyrå som er nytenkende og kostnadseffektivt, samtidig som det leverer høykompetent helsepersonell til en lavere pris. Hans ambisjon er å bidra til en bærekraftig løsning på sykepleiermangelen ved å tilby høy kvalitet til helsevesenet, samtidig som helsepersonell får bedre lønn og arbeidsforhold.',
      ],
      pullQuote: 'Norvig er bygget av en som har gått veien selv — og som vet hva som faktisk fungerer.',
    },
    ctaTitle: 'Vil du bli kjent med oss?',
    ctaSub: 'Vi svarer gjerne på spørsmål om plattformen, samarbeid eller karriere hos Norvig.',
    ctaPrimary: 'Kontakt teamet',
    ctaSecondary: 'Les historier',
    investors: {
      eyebrow: 'Investor-relasjoner',
      title: 'For investorer.',
      body: 'Norvig vurderer investorer i skaleringsfase. Materialet er fortrolig og krever passord.',
      cta: 'Logg inn som investor',
    },
  },
  historier: {
    pageEyebrow: '—— Historier',
    pageTitleA: 'Ekte mennesker.',
    pageTitleB: 'Ekte reiser.',
    pageSub: 'Bak hvert tall i statistikken er det et menneske som har turt å begynne på nytt. Her er noen av reisene som har formet Norvig.',
    storyEyebrow: 'Historie',
    storyEntryLabel: 'Historie',
    ctaRead: 'Les hele historien',
    ctaBack: 'Tilbake til alle historier',
    ctaJoinNext: 'Din historie kan bli den neste.',
    ctaJoinNextSub: 'Norvig hjelper deg fra første søknad til første arbeidsdag — og lenge etter.',
    ctaJoinNextPrimary: 'Start din reise',
    ctaJoinNextSecondary: 'Tilbake til forsiden',
    headerCtaRegister: 'Registrer deg',
    fromCountry: 'Fra',
    detailHero: 'Reisen',
    inNumbers: '——— I tall',
    timeline: '——— Tidslinjen',
    timelineTitleA: 'Steg for',
    timelineTitleB: 'steg.',
    timelineSub: 'Ingen suksesshistorie er bygd over natten. Her er reisen — fra første skritt til der vi er i dag.',
    journeyEyebrow: '——— Reisen',
    keyPointsEyebrow: '——— Høydepunkter',
    inOwnWords: '——— I egne ord',
    relatedEyebrow: '——— Andre historier',
    relatedTitleA: 'Flere som har funnet',
    relatedTitleB: 'sin plass.',
    relatedSeeAll: 'Se alle historier',
    yourTurnEyebrow: '——— Din tur',
    yourTurnTitleA: 'Den neste historien',
    yourTurnTitleB: 'kan være din.',
    yourTurnSub: 'Norvig hjelper deg fra første søknad til første arbeidsdag — og lenge etter.',
    yourTurnPrimary: 'Start din reise',
    yourTurnSecondary: 'Alle historier',
    shareBtn: 'Del',
    shareTitle: 'Del historien',
    detailCtaRegister: 'Bli neste historie',
    notFoundEyebrow: '——— Historie 404',
    notFoundTitle: 'Vi fant ikke historien.',
    notFoundSub: 'Lenken kan være feil eller historien er ikke publisert ennå.',
    notFoundCta: 'Tilbake til alle historier',
    pageTitleSuffix: 'Norvig',
  },
  onboarding: {
    welcome: {
      eyebrow: '——— Velkommen',
      titleA: 'La oss bygge',
      titleB: 'profilen din.',
      lede: 'Det tar omtrent 4 minutter. Vi spør om bakgrunn, ønsket arbeidssted og litt om livet ditt — så vi kan koble deg til stillinger som faktisk passer.',
      bullets: [
        { label: 'Treffsikker matching', desc: 'Vi vekter både kompetanse og preferanser.' },
        { label: 'Stillinger der omsorg trengs', desc: 'Sykehjem, hjemmetjeneste og helsehus — samt oppvekst og utdanning.' },
        { label: 'Personlig oppfølging', desc: 'Hele veien — også etter første arbeidsdag.' },
      ],
      startCta: 'Start oppsettet',
    },
    sidebar: {
      eyebrow: '——— Profil-oppsett',
      titleA: 'Et nytt',
      titleB: 'kapittel.',
      intro: 'Vi bruker noen minutter på å sette opp profilen din. Det hjelper oss finne stillinger som passer kompetansen og livet ditt.',
      start: 'Start',
      stepNOf: (n, total) => `Steg ${String(n).padStart(2, '0')} av ${String(total).padStart(2, '0')}`,
      stepLabels: { 1: 'Om deg', 2: 'Bakgrunn', 3: 'Preferanser', 4: 'Livet ditt' },
      savedAuto: 'Lagres automatisk',
      savedAutoHint: 'Fremgangen din lagres i 7 dager — du kan trygt fullføre senere.',
      finishLater: 'Fullfør senere',
      back: 'Tilbake',
      next: 'Neste',
      saveAndContinue: 'Lagre og fortsett',
      skip: 'Hopp over',
      saving: 'Lagrer …',
      finish: 'Fullfør profilen',
      logout: 'Logg ut',
      logoutTitle: 'Logge ut nå?',
      logoutBody: 'Du er midt i profil-oppsettet. Vi lagrer fremgangen din lokalt i 7 dager, så du kan fortsette der du slapp neste gang du logger inn.',
      logoutCancel: 'Bli her',
      logoutConfirm: 'Logg ut',
      pause: 'Pause',
      pauseTooltip: 'Lagre fremgang og fortsett senere',
      pauseToast: 'Fremgang lagret — fortsett når du vil.',
    },
    step1: {
      eyebrow: 'Om deg',
      title: 'Hvem er du?',
      subtitle: 'La oss begynne med det grunnleggende. Disse opplysningene hjelper oss skreddersy matching.',
      nameLabel: 'Fullt navn',
      namePlaceholder: 'F.eks. Maria Santos',
      nameError: 'Vi trenger navnet ditt',
      nationalityLabel: 'Nasjonalitet',
      nationalityPlaceholder: 'Velg land — eller skriv for å søke',
      nationalitySearchPlaceholder: 'Søk land …',
      nationalityQuickPicks: 'Vanlige valg',
      nationalityAllCountries: 'Alle land',
      nationalityEmpty: 'Fant ingen treff. Prøv et annet søk.',
      nationalityClear: 'Fjern valg',
      nationalityError: 'Hvor kommer du fra?',
      languagesLabel: 'Språk du behersker',
      languagesHint: 'Velg alle språkene du behersker. Trykk «Annet» for å legge til flere.',
      languagesError: 'Velg minst ett språk',
      otherToggle: 'Annet',
      otherInputPlaceholder: 'Skriv inn et språk …',
      otherInputAdd: 'Legg til',
      otherRemoveLabel: 'Fjern språk',
    },
  },
  profile: {
    pageEyebrow: '—— Profil',
    pageTitle: 'Din profil.',
    backToDashboard: 'Tilbake til dashbord',
    editProfile: 'Rediger profil',
    completenessLabel: 'Profil-fullstendighet',
    notFilledYet: 'Ikke fylt ut ennå',
    fillIn: 'Fyll ut',
    fillInProfile: 'Fyll ut profilen',
    completeTips: {
      title: 'Fullfør profilen din',
      body: 'For å øke matching-muligheter, fyll ut disse feltene:',
      cta: 'Rediger profil',
      progress: '{filled} av 10 felt fylt ut · {missing} gjenstår',
    },
    availableFromLabel: 'Tilgjengelig fra',
    availableImmediate: 'Umiddelbart',
    sections: {
      personal: 'Personlig informasjon',
      information: 'Opplysninger',
      background: 'Bakgrunn',
      preferences: 'Preferanser',
      about: 'Om meg',
      documents: 'Dokumenter',
    },
    fields: {
      fullName: 'Fullt navn',
      companyName: 'Firmanavn',
      nationality: 'Nasjonalitet',
      languages: 'Språk',
      familyStatus: 'Sivilstatus',
      familyInfo: 'Familie',
      email: 'E-post',
      phone: 'Telefon',
      profession: 'Yrkestittel',
      sector: 'Sektor',
      yearsExperience: 'År med erfaring',
      experienceYears: 'År med erfaring',
      certifications: 'Sertifikater & autorisasjoner',
      skills: 'Kompetanse',
      education: 'Utdanning',
      workHistory: 'Arbeidshistorikk',
      preferredShift: 'Foretrukket skift',
      employmentType: 'Stillingstype',
      locationPreferences: 'Ønsket sted',
      housingPreference: 'Bolig',
      salaryExpectation: 'Lønnsforventning',
      availableFrom: 'Tilgjengelig fra',
      interests: 'Interesser',
    },
    emptyDocs: 'Ingen dokumenter lastet opp ennå.',
    uploadDocument: 'Last opp dokument',
    nationalityFlagAlt: 'Flagg for',
    titleNotSet: 'Yrkestittel ikke satt',
    brreg: {
      orgnrLabel: 'Organisasjonsnummer',
      orgnrPlaceholder: '9 sifre',
      orgnrInvalid: 'Må være 9 siffer',
      fetchCta: 'Hent fra BRREG',
      fetching: 'Henter …',
      saveCta: 'Lagre',
      saving: 'Lagrer …',
      saveConfirmTitle: 'Bekreft lagring',
      saveConfirmBody: 'Organisasjonsnummeret låses etter lagring. Endring krever support.',
      saveConfirmYes: 'Lagre og lås',
      saveConfirmNo: 'Avbryt',
      lockedNote: 'Organisasjonsnummer er låst — ',
      lockedSupportLink: 'kontakt support for endring',
      refreshCta: 'Oppdater fra BRREG',
      refreshing: 'Oppdaterer …',
      lastUpdated: 'Sist oppdatert',
      errors: {
        notFound: 'Organisasjonsnummer ikke funnet i BRREG',
        unavailable: 'BRREG er utilgjengelig akkurat nå. Prøv igjen om litt.',
        generic: 'Noe gikk galt. Prøv igjen.',
      },
      fields: {
        firmanavn: 'Firmanavn',
        organisasjonsform: 'Organisasjonsform',
        registreringsstatus: 'Registreringsstatus',
        registreringsdato: 'Registreringsdato',
        stiftelsesdato: 'Stiftelsesdato',
        mva_registrering: 'MVA-registrering',
        antall_ansatte: 'Antall ansatte',
        hjemmeside: 'Hjemmeside',
        epostadresse: 'E-postadresse',
        telefonnummer: 'Telefonnummer',
        forretningsadresse: 'Forretningsadresse',
        postadresse: 'Postadresse',
        kommune: 'Kommune',
        fylke: 'Fylke',
        land: 'Land',
        naeringskode: 'Næringskode (NACE)',
        bransjebeskrivelse: 'Bransjebeskrivelse',
      },
    },
    photo: {
      uploadCta: 'Last opp foto',
      changeCta: 'Bytt foto',
      removeCta: 'Fjern foto',
      uploading: 'Laster opp …',
      successToast: 'Foto oppdatert.',
      removedToast: 'Foto fjernet.',
      errorTooLarge: 'Bildet er for stort. Maks 5 MB.',
      errorBadType: 'Filformatet støttes ikke. Bruk JPEG, PNG eller WebP.',
      errorGeneric: 'Noe gikk galt under opplastingen. Prøv igjen.',
      cropper: {
        title: 'Beskjær foto',
        hint: 'Dra for å justere · scroll eller bruk slider for zoom',
        zoomLabel: 'Zoom',
        rotate: 'Roter 90°',
        skip: 'Hopp over beskjæring',
        cancel: 'Avbryt',
        confirm: 'Bruk utsnitt',
        processing: 'Behandler …',
      },
    },
  },
  analytics: {
    eyebrow: '02 — Analyse',
    title: 'Tall som',
    italicSuffix: 'forteller.',
    subtitle: 'Hvordan stillingene dine fanger oppmerksomhet — og hvem som svarer.',
    kpi: {
      applicationsLast7d: 'Søknader · siste 7 dager',
      applicationsTotal: 'Søknader · totalt',
      avgPerJob: 'Snitt søknader/jobb',
      activeConversations: 'Aktive samtaler',
      verifiedCandidatesMarket: 'Verifiserte kandidater i markedet',
      verifiedCandidatesInSector: 'verifiserte kandidater i',
      activeJobs: 'Aktive stillinger',
    },
    charts: {
      perWeekTitle: 'Søknader per uke',
      perWeekSubtitle: 'Siste 8 uker',
      bySectorTitle: 'Søknader per sektor',
      bySectorSubtitle: 'Fordeling på tvers av sektorer',
      inSectorSubtitle: 'Søknader i sektoren din',
      recentTitle: 'Nylige søknader',
      recentSubtitle: 'Siste 10 søknader, nyeste først',
      weekAxis: 'Uke',
      countAxis: 'Antall',
    },
    status: {
      pending: 'Venter',
      reviewed: 'Sett',
      contacted: 'Kontaktet',
      rejected: 'Avslått',
    },
    empty: {
      title: 'Kom i gang',
      subtitle: 'Når søknadene begynner å komme inn, ser du tall, trender og fordeling her.',
    },
    loading: 'Laster analyse …',
    csv: {
      download: 'Eksporter CSV',
      downloading: 'Laster ned …',
      tooltip: 'Last ned som CSV (Excel-vennlig)',
    },
    funnel: {
      eyebrow: 'Konverteringsfunnel',
      subtitle: 'Hvordan engasjement utvikler seg, siste 30 dager',
      conversionLabel: 'av',
      tooltipPrefix: 'Du gjorde',
      tooltipSearches: 'søk',
      tooltipViews: 'profil-visninger',
      tooltipContacts: 'samtaler',
      tooltipDays: 'siste 30 dager',
    },
    topCandidates: {
      eyebrow: 'Mest sett',
      subtitle: 'Kandidater du har vendt tilbake til',
      timesSeen: 'Sett',
      timesSeenSuffix: 'ganger',
      lastViewed: 'sist sett',
      emptyTitle: 'Ingen visninger ennå',
      emptySubtitle: 'Begynn å utforske kandidater for å se trender her.',
    },
    topSkills: {
      eyebrow: 'Topp ferdigheter',
      subtitle: 'Hva du leter etter, siste 30 dager',
      searchedNTimes: 'søk',
      emptyTitle: 'Ingen søk ennå',
      emptySubtitle: 'Når du begynner å bruke filtre i kandidat-søk, ser du de mest brukte her.',
    },
    trendDaily: {
      eyebrow: 'Aktivitet · 30 dager',
      subtitle: 'Søk, visninger og nye samtaler dag for dag',
      searches: 'Søk',
      views: 'Visninger',
      contacts: 'Samtaler',
    },
    shortlist: {
      eyebrow: 'Din shortlist',
      subtitle: 'Kandidater du har lagret for oppfølging',
      saveTooltip: 'Lagre i shortlist',
      unsaveTooltip: 'Fjern fra shortlist',
      saveSuccess: 'Lagt til i shortlist',
      unsaveSuccess: 'Fjernet fra shortlist',
      emptyTitle: 'Ingen kandidater enda',
      emptySubtitle: 'Trykk hjerteikonet på et kandidatkort for å lagre.',
      viewedNTimes: 'sett',
      timesShort: 'g',
      cvLabel: 'CV',
      certCountSuffix: 'sertifikater',
      certCountSuffixSingular: 'sertifikat',
      remove: 'Fjern',
      suggestionsEyebrow: 'Forslag · basert på dine visninger',
      suggestionsCta: 'Lagre',
      suggestionsViewSuffix: 'visninger',
    },
  },
  dashboard: {
    marketIndex: {
      title: 'Markedsindeks i din sektor',
      period: 'siste 30 dager',
      vsPrev: 'vs. forrige 30 d',
      loading: 'Henter markedsdata …',
    },
  },
  horisont: {
    eyebrowPrefix: 'Nº 06',
    label: 'Horisont',
    title: 'Horisont',
    italicSuffix: '— perspektiv.',
    subtitle: 'Perspektiv på mennesker, kompetanse og fremtidens arbeidsliv.',
    intro: 'Vi skriver fra innsiden av norsk rekruttering — om strukturer som svikter, modeller som virker, og menneskene som binder det sammen.',
    featuredLabel: 'Anbefalt artikkel',
    moreComing: 'Flere artikler kommer snart.',
    minReadSuffix: 'min lesetid',
    byAuthor: 'Av',
    publishedOn: 'Publisert',
    tagsLabel: 'Stikkord',
    relatedTitle: 'Relaterte artikler',
    backToList: 'Tilbake til Horisont',
    moreArticles: 'Les flere artikler',
    notFoundTitle: 'Artikkelen finnes ikke',
    notFoundBody: 'Vi fant ikke artikkelen du leter etter. Kanskje den har flyttet — eller kommer snart.',
    notFoundCta: 'Tilbake til Horisont',
    readArticleCta: 'Les artikkelen',
    authorBioEyebrow: 'Om forfatteren',
    sourcesLabel: 'Kilder',
    newsletter: {
      eyebrow: 'Få neste essay',
      title: 'Bli med på listen.',
      subtitle: 'Ett essay hver måned om mennesker, kompetanse og norsk arbeidsliv. Ingen spam.',
      placeholder: 'din@epost.no',
      submit: 'Abonner',
      submitting: 'Sender …',
      successTitle: 'Takk!',
      successBody: 'Du er på listen. Vi skriver til deg når neste essay er klart.',
      errorGeneric: 'Noe gikk galt. Prøv igjen om litt.',
      errorInvalid: 'Vennligst skriv en gyldig e-postadresse.',
      errorRateLimit: 'For mange forsøk. Prøv igjen om et par minutter.',
      privacyNote: 'Vi deler aldri e-posten din. Avmeld når som helst.',
    },
    share: {
      button: 'Del artikkel',
      tooltip: 'Del artikkel',
      copied: 'Lenke kopiert',
      failed: 'Kunne ikke dele',
      rowLabel: 'Del artikkelen',
      linkedin: 'Del på LinkedIn',
      email: 'Del via e-post',
    },
  },
  messages: {
    pageEyebrow: '01 — Direkte kontakt',
    pageTitle: 'Samtaler med',
    pageItalic: 'kommuner.',
    pageTitleCandidate: 'Samtaler med',
    pageItalicCandidate: 'fagarbeidere.',
    pageSubtitle: 'Snakk direkte. Uten mellomledd. Uten gebyrer.',
    back: 'Dashboard',
    listHeader: 'Samtaler',
    emptyListTitle: 'Ingen samtaler ennå',
    emptyListBody: 'Når du starter en samtale med en kandidat, vises den her.',
    emptyListBodyCandidate: 'Når en kommune kontakter deg, vises samtalen her.',
    selectTitle: 'Velg en samtale',
    selectBody: 'Velg en samtale fra listen for å se meldinger.',
    inputPlaceholder: 'Skriv en melding ...',
    sendBtn: 'Send',
    sending: 'Sender ...',
    employerLabel: 'Kommune',
    candidateLabel: 'Fagarbeider',
    unreadBadge: 'ny',
    unreadBadgePlural: 'nye',
    archivedTag: 'Arkivert',
    archive: 'Arkiver samtale',
    archiveConfirm: 'Skjul denne samtalen fra din innboks? Den andre parten vil fortsatt se den.',
    archived: 'Samtale arkivert',
    archiveError: 'Kunne ikke arkivere samtalen',
    sendError: 'Kunne ikke sende meldingen',
    quickReplyLabel: 'Hurtigsvar:',
    quickReplyYes: 'Ja, del gjerne',
    quickReplyYesText: 'Ja, del gjerne — dokumentene mine er tilgjengelige for dere.',
    quickReplyTellMore: 'Fortell mer om stillingen',
    quickReplyTellMoreText: 'Takk for interessen! Fortell gjerne mer om stillingen dere har i tankene.',
    showMap: 'Vis kart',
    hideMap: 'Skjul kart',
    loadError: 'Kunne ikke laste samtaler',
    adminAuditBanner: 'Du ser alle samtaler på plattformen. Du kan svare og starte nye samtaler — meldingene dine merkes som Norvig.',
    adminCantSend: 'Admin-konto kan ikke sende meldinger',
    softDeletedForMe: 'Skjult for én part',
    startNew: {
      eyebrow: 'Ny samtale',
      title: 'Send melding til kandidaten',
      subtitle: 'Den første meldingen din starter samtalen. Vær konkret om stillingen og hvorfor du tar kontakt.',
      subtitleAdmin: 'Du skriver på vegne av Norvig. Kandidaten ser tydelig at meldingen kommer fra plattform-teamet.',
      placeholder: 'Hei, vi har en stilling som matcher profilen din ...',
      submit: 'Send melding',
      cancel: 'Avbryt',
      sent: 'Meldingen er sendt',
      tooShort: 'Skriv minst 1 tegn',
      crossSector: 'Kandidaten tilhører en annen sektor og kan ikke kontaktes herfra.',
      missingSector: 'Sett organisasjonens sektor før du sender meldinger.',
      notFound: 'Kandidaten ble ikke funnet.',
      genericError: 'Noe gikk galt. Prøv igjen.',
    },
    newMessageToast: 'Du har en ny melding',
    sendCta: 'Send melding',
  },
  investors: {
    gate: {
      brand: 'Norvig',
      eyebrow: 'For investorer',
      title: 'En invitasjon i fortrolighet.',
      subtitle: 'Denne siden er kun for godkjente investorer. Skriv inn passord for å fortsette.',
      placeholder: 'Passord',
      submit: 'Få tilgang',
      submitting: 'Verifiserer ...',
      errorWrong: 'Feil passord. Prøv igjen.',
      errorRate: 'For mange forsøk. Vent 1 minutt før du prøver igjen.',
      errorGeneric: 'Noe gikk galt. Prøv igjen om et øyeblikk.',
      backLink: '← Tilbake til Norvig',
    },
    hero: {
      eyebrow: '01 — Investor-deck',
      title: 'Norge mangler arbeidskraft.',
      titleItalic: 'Vi bygger broen.',
      lede: 'Norvig forbinder dyktige internasjonale fagarbeidere med norske kommuner — sektor for sektor.',
      tagline: 'En invitasjon til investorer i skaleringsfase.',
      ctaScroll: 'Les videre',
    },
    market: {
      eyebrow: '02 — Markedsbehov',
      title: 'Hvorfor det haster.',
      stats: [
        { value: '76 000+', label: 'årsverk kan mangle i helse og omsorg innen 2035', source: 'SSB-prognose' },
        { value: '6 av 10', label: 'kommuner sliter med å rekruttere nok fagfolk til helse og oppvekst', source: 'KS Arbeidsgivermonitor' },
        { value: '2', label: 'kritiske offentlige sektorer rammet av kronisk arbeidskraftsmangel', source: 'NAV' },
      ],
      kicker: 'Velferdsstaten avhenger av at vi løser dette — og vi kan ikke vente på politisk reform.',
    },
    solution: {
      eyebrow: '03 — Vår løsning',
      title: 'Internasjonal arbeidskraft.',
      titleItalic: 'Sektor-spesifikk plattform.',
      leftHead: 'Bærekraftig tilgang på fagarbeidere',
      leftBody: 'Norge kan ikke utdanne seg ut av arbeidskraftmangelen. Polske helsearbeidere er allerede en kjerne-ressurs i nordisk eldreomsorg — og pipeline-en fra Slovakia, Litauen og Romania er nettopp åpnet. Norvig kvalitetssikrer dette stille kapittelet, papir for papir, sertifikat for sertifikat.',
      rightHead: 'To sektorer. To distinkte flyter.',
      rightBody: 'Generiske rekrutteringsplattformer faller på sektor-spesifikk kompleksitet — språkkrav, autorisasjon, godkjenning av utdanning. Norvig bygger fokuserte arbeidsflyter for Helse & omsorg og Oppvekst & utdanning. Kandidaten ser kun det som er relevant. Kommunen ser kun kvalifiserte kandidater i sin sektor.',
    },
    platform: {
      eyebrow: '04 — Plattformen',
      title: 'Bygget med dybde.',
      cards: [
        { name: 'BRREG-integrasjon', body: 'Automatisk verifisering av kommuner via Enhetsregisteret. Ingen falske organisasjoner — alle sektor-låses ved første onboarding.' },
        { name: 'Sektor-segmentert pool', body: 'Kandidater og kommuner møtes innenfor strenge sektor-rammer. Garantert relevant matching.' },
        { name: 'AI-assistert matching', body: 'Yrkestittel + sektor + kompetanseområder kombineres til en match-score. Manuell overstyring ivaretas.' },
        { name: 'End-to-end messaging', body: 'Direkte kommunikasjon mellom kommune og kandidat. Sektor-låst. Audit-trail for tilsynsmyndigheter.' },
        { name: 'Audit-trail & data-helse', body: 'Hver handling logges. Et "Fiks alt"-verktøy holder data ren mens vi skalerer.' },
        { name: 'Bilateralt onboarding', body: 'Kandidat- og kommune-flyt er fullstendig adskilte, men sektor-symmetriske. Begge sider eier sin egen kvalitet.' },
      ],
    },
    traction: {
      eyebrow: '05 — Tidlig traksjon',
      title: 'Plattformen er i drift.',
      sub: 'Tallene under er live fra produksjon — ikke prognoser eller mål.',
      candidates: 'kandidater registrert',
      employers: 'kommuner onboardet',
      orgs: 'organisasjoner verifisert via BRREG',
      conversations: 'aktive samtaler',
      sampleHead: 'Eksempler på kommuner på plattformen:',
      loadingError: 'Kunne ikke laste tall fra plattformen.',
    },
    team: {
      eyebrow: '06 — Teamet',
      title: 'Bygget av noen som har gått veien.',
      kastriot: {
        name: 'Kastriot Prenga',
        role: 'Gründer av Norvig AS',
        eyebrow: 'Om grunnleggeren',
        paragraphs: [
          'Norvig er bygget av en grunnlegger med dyp operativ innsikt i norsk helsesektor. Kastriot Prenga har jobbet som helsefagarbeider, sykepleier og fagleder på tvers av sykehus, sykehjem og hjemmesykepleie — og kjenner hverdagens flaskehalser fra innsiden.',
          'Som hovedtillitsvalgt og fylkesstyrerepresentant i Norsk Sykepleierforbund Vestland har han forhandlet arbeidsvilkår, turnuser og lønn på vegne av tusenvis av sykepleiere. Det gir Norvig en sjelden kombinasjon: tillit blant helsepersonellet, og forståelse for hva helseforetak og kommuner faktisk kan kjøpe.',
          'Erfaring fra bemanningsbransjen har gitt ham et tydelig bilde av hvor dagens vikarbyråer svikter — både i pris til oppdragsgivere og i opplevd kvalitet hos helsepersonellet.',
          'Norvig er svaret: et rekrutterings- og bemanningsbyrå designet for å levere høykompetent helsepersonell til lavere kostnad, samtidig som personellet får bedre lønn og forutsigbare vilkår. Ambisjonen er en bærekraftig, skalerbar løsning på sykepleiermangelen — et marked som vil vokse i Norge gjennom hele 2030-tallet.',
        ],
        closingQuote: {
          text: 'Jeg har sett problemet fra alle sider. Det Norvig løser, har ingen andre løst med samme dybde.',
          attribution: '— Kastriot Prenga, grunnlegger',
        },
      },
      others: [
        // MOVED to DB: `team_portraits` collection (show_on_investors=true).
        // Consumed via usePublicTeamPortraits() → /api/team-portraits.
      ],
    },
    growth: {
      eyebrow: '07 — Vekstplan',
      title: 'Hva investeringen muliggjør.',
      cards: [
        { num: '01', head: 'Skalere kommunebasen', body: 'Bygge en base på 500+ aktive kommuner i Norge innen 18 måneder.' },
        { num: '02', head: 'Utvide kandidat-pool geografisk', body: 'Bygge dedikerte rekrutteringspartnerskap i Slovakia, Litauen og Romania, parallelt med eksisterende polske kanaler.' },
        { num: '03', head: 'Compliance-modul', body: 'Direkte integrasjon mot NAV og Skatteetaten. Automatisk håndtering av sykmeldinger og dokumentflyt.' },
        { num: '04', head: 'Salg & merkevare', body: 'Bygge en merkevare som kommuner oppsøker fremfor selv-å bli oppsøkt. Norvig som standarden, ikke alternativet.' },
      ],
    },
    contact: {
      eyebrow: '08 — Kontakt',
      title: 'Vi søker investorer.',
      sub: 'Norvig er i skaleringsfase. Vi tar imot samtaler i fortrolighet.',
      labels: {
        name: 'Navn',
        company: 'Selskap (valgfritt)',
        email: 'E-post',
        phone: 'Telefon (valgfritt)',
        message: 'Melding',
        messagePlaceholder: 'Fortell oss om din interesse — bransjeerfaring, ticket size, tidshorisont.',
        submit: 'Send melding',
        submitting: 'Sender ...',
      },
      success: {
        title: 'Takk for henvendelsen.',
        body: 'Vi tar kontakt innen 48 timer.',
        again: 'Send en ny henvendelse',
      },
      direct: 'Eller send direkte til',
      directEmail: 'investor@norvig.no',
      errors: {
        required: 'Navn, e-post og melding må fylles ut.',
        emailFormat: 'Skriv inn en gyldig e-postadresse.',
        rate: 'Du har sendt mange henvendelser nylig. Vent en time før du prøver igjen.',
        generic: 'Noe gikk galt. Prøv igjen.',
      },
    },
    footer: {
      brand: 'Norvig · For investorer',
      confidential: 'Materialet er fortrolig og kun ment for adresserte mottakere.',
      contactBack: 'Tilbake til Norvig.no',
    },
  },

  terms: {
    pageTitle: 'Forretningsvilkår',
    pageEyebrow: 'Nº 11 — FORRETNINGSVILKÅR',
    lastUpdatedLabel: 'Sist oppdatert',
    versionLabel: 'Versjon',
    backLabel: 'Tilbake',
    questionsHeading: 'Spørsmål?',
    questionsBody: 'Send oss en e-post på',
    signupCheckboxBefore: 'Jeg har lest og godkjenner Norvigs',
    signupCheckboxLink: 'forretningsvilkår',
    signupCheckboxRequired: 'Du må godkjenne forretningsvilkårene før du fortsetter.',
    profile: {
      heading: 'Forretningsvilkår',
      acceptedOn: 'Du godkjente vilkår versjon {version} den {date}',
      neverAccepted: 'Du har ikke godkjent vilkårene ennå.',
      lastViewed: 'Sist sett av deg: {date}',
      neverViewed: 'Du har ikke åpnet vilkårene etter aksept.',
      currentVersion: 'Gjeldende versjon i Norvig: {version}',
      viewButton: 'Se forretningsvilkår',
    },
    modal: {
      heading: 'Oppdaterte forretningsvilkår',
      subtext: 'Vi har oppdatert vilkårene våre. Vennligst les og godkjenn for å fortsette.',
      accept: 'Jeg godkjenner',
      openInNewTab: 'Åpne i ny fane',
      acceptHint: 'Knappen aktiveres når du har lest til bunns.',
      submitting: 'Lagrer …',
    },
  },

  employment: {
    heading: 'Meld arbeidsforhold',
    subtext: 'Plikt etter pkt. 5 i forretningsvilkårene — varsle innen 40 dager etter inngått arbeidsforhold.',
    openButton: 'Meld nytt arbeidsforhold',
    list: {
      heading: 'Mine meldte arbeidsforhold',
      empty: 'Du har ingen meldte arbeidsforhold ennå.',
      cols: {
        employer: 'Kommune',
        position: 'Stillingstittel',
        start: 'Startdato',
        type: 'Type',
        source: 'Kontakt-kilde',
        submitted: 'Meldt',
        status: 'Status',
      },
      statusSubmitted: 'Innsendt',
      statusReviewed: 'Sett av Norvig',
    },
    types: {
      fast: 'Fast',
      midlertidig: 'Midlertidig',
      vikar: 'Vikar',
      freelance: 'Freelance',
      annet: 'Annet',
    },
    sources: {
      via_norvig: 'Gjennom Norvig',
      outside_norvig: 'Utenfor Norvig',
    },
    form: {
      title: 'Meld nytt arbeidsforhold',
      subtitle: 'Fyll inn detaljer om arbeidsforholdet ditt. Vi varsler ikke kommunen — meldingen er konfidensiell.',
      employerName: 'Kommune-navn',
      employerNamePlaceholder: 'F.eks. Riksrevisjonen, Helse Bergen',
      employerOrgnr: 'Org.nr (valgfri)',
      employerOrgnrPlaceholder: '9 siffer',
      norvigMemberBadge: 'Norvig-medlem',
      positionTitle: 'Stillingstittel',
      positionTitlePlaceholder: 'F.eks. Sykepleier, Helsefagarbeider',
      startDate: 'Startdato',
      employmentType: 'Type stilling',
      contactSource: 'Kontakt opprettet via',
      notes: 'Tilleggsinformasjon (valgfri)',
      notesPlaceholder: 'Eventuelle merknader …',
      cancel: 'Avbryt',
      submit: 'Send melding',
      submitting: 'Sender …',
      success: 'Takk — Norvig har mottatt din melding.',
      errorGeneric: 'Kunne ikke sende melding. Prøv igjen.',
      errorRateLimit: 'Du har nådd dagens grense på 5 meldinger. Prøv igjen i morgen.',
      brregLookupNotFound: 'Fant ikke organisasjon med dette nummeret',
      brregLookupOk: 'Bekreftet i Enhetsregisteret',
    },
  },

  admin: {
    compliance: {
      eyebrow: 'Nº 03 — VARSLINGSPLIKT · TOS',
      title: 'Etterlevelse',
      italicSuffix: 'oversikt.',
      subtitle: 'Sanntidsoversikt over aksept av forretningsvilkår og innmeldte arbeidsforhold.',
      tiles: {
        acceptanceRate: 'AKSEPT-RATE',
        acceptanceRateHint: '{n} av {total} aktive fagarbeidere har godkjent gjeldende versjon.',
        pending: 'AVVENTER AKSEPT',
        pendingHint: 'Aktive fagarbeidere må godkjenne ved neste innlogging.',
        unreviewed: 'IKKE GJENNOMGÅTT',
        unreviewedHint: 'Meldte arbeidsforhold venter på admin-gjennomgang.',
        unreviewedCta: 'Åpne kø',
        outside: 'EKSTERNE KONTAKTER · 30D',
        outsideHint: 'Arbeidsforhold inngått utenfor portalen siste 30 dager.',
        employerAcceptanceRate: 'KOMMUNE-AKSEPT',
        employerAcceptanceHint: '{n} av {total} aktive kommuner har godkjent gjeldende versjon.',
        employerPending: 'ARB.GIV. AVVENTER',
        employerPendingHint: 'Aktive kommuner må godkjenne ved neste innlogging.',
        hireReportsUnreviewed: 'MELDTE ANSETTELSER · IKKE GJENNOMGÅTT',
        hireReportsUnreviewedHint: 'Meldte ansettelser venter på admin-gjennomgang.',
        hireReportsPendingFee: 'GEBYR AVVENTER FAKTURERING',
        hireReportsPendingFeeHint: 'Ansettelser med fee_status=pending.',
      },
      footer: {
        exempt: '{n} fagarbeidere unntatt (inaktive > 2 år)',
        openAdmin: 'Åpne admin-side',
      },
      email: {
        sendNow: 'Send sammendrag nå',
        confirmTitle: 'Send compliance-sammendrag nå?',
        confirmBody: 'Du sender en daglig oppsummering på e-post til alle admin-brukere. Handlingen logges i revisjonsporet.',
        confirmCancel: 'Avbryt',
        confirmConfirm: 'Send nå',
        sending: 'Sender …',
        successSent: 'Sammendrag sendt til {n} admin(er).',
        successDevMode: 'Dev-modus — sammendrag logget til konsoll for {n} admin(er). Sett RESEND_API_KEY i .env for ekte utsending.',
        rateLimit: 'Vent et øyeblikk — du har sendt 3 ganger denne timen.',
        genericError: 'Kunne ikke sende sammendrag.',
        openLog: 'Se e-post-logg',
      },
    },
    emailLog: {
      pageEyebrow: 'NORVIG · ADMIN',
      title: 'E-post-logg',
      italicSuffix: 'revisjonsspor.',
      subtitle: 'Alle utsendte og dev-loggede systemmeldinger med snapshot av data ved send.',
      filters: {
        type: 'Type',
        status: 'Status',
        from: 'Fra dato',
        to: 'Til dato',
        all: 'Alle',
        apply: 'Bruk filtre',
        reset: 'Tilbakestill',
      },
      types: {
        daily_compliance_summary: 'Daglig compliance-sammendrag',
        terms_update_notification: 'Vilkår-oppdatering',
      },
      statuses: {
        sent: 'Sendt',
        dev_logged: 'Dev-logget',
        failed: 'Feilet',
      },
      tracking: {
        delivered: 'Levert',
        opened: 'Åpnet',
        clicked: 'Klikket',
        bounced: 'Avvist',
        lastClicked: 'Sist klikkede lenke',
        hint: 'Åpne-/klikksporing krever en Resend-webhook (hendelser: delivered, opened, clicked, bounced) som peker til:',
        suppress: 'Hopp over ved kunngjøringer',
        suppressed: 'Hoppes over',
        suppressedInfo: 'Denne adressen hoppes over ved kunngjøringer.',
        unsuppress: 'Angre',
      },
      cols: {
        sentAt: 'Tid',
        type: 'Type',
        recipient: 'Mottaker',
        subject: 'Emne',
        status: 'Status',
        triggeredBy: 'Trigget av',
        detail: 'Detalj',
      },
      triggeredBy: {
        scheduled: 'Planlagt (cron)',
        manual_admin: 'Manuell (admin)',
      },
      detail: {
        bodyPreview: 'Innhold (utdrag)',
        snapshot: 'Data-snapshot ved send',
        provider: 'Leverandør',
        providerMessageId: 'Melding-ID',
        error: 'Feilmelding',
        close: 'Lukk detalj',
      },
      empty: 'Ingen e-poster sendt ennå.',
      back: 'Tilbake til admin',
      pagination: {
        showing: 'Viser {from}–{to} av {total}',
        prev: 'Forrige',
        next: 'Neste',
      },
    },
    documents: {
      pageEyebrow: 'NORVIG · ADMIN',
      title: 'Brukerdokumenter',
      italicSuffix: 'tilgang og audit.',
      subtitle: 'Alle dokumenter lastet opp av fagarbeidere — med tilgangs-statistikk og hard-delete for GDPR-forespørsler.',
      filters: {
        ownerEmail: 'Eier-e-post',
        category: 'Kategori',
        mimeType: 'Filtype',
        includeDeleted: 'Inkluder slettede',
        all: 'Alle',
        apply: 'Bruk filtre',
        reset: 'Tilbakestill',
      },
      cols: {
        owner: 'Eier',
        category: 'Kategori',
        filename: 'Filnavn',
        size: 'Størrelse',
        uploaded: 'Opplastet',
        views30d: 'Visn. (30d)',
        downloads30d: 'Nedl. (30d)',
        actions: 'Handling',
      },
      actions: {
        viewLog: 'Vis logg',
        hardDelete: 'Hard slett',
        exportCsv: 'Eksporter CSV',
      },
      accessLog: {
        heading: 'Tilgangslogg',
        empty: 'Ingen tilganger registrert.',
        cols: {
          when: 'Tidspunkt',
          who: 'Bruker',
          role: 'Rolle',
          type: 'Type',
          ip: 'IP',
        },
        types: {
          view_metadata: 'Visning',
          download: 'Nedlasting',
          preview: 'Forhåndsvisning',
        },
      },
      hardDeleteConfirm: 'Permanent slette dette dokumentet og fjerne filen fra disk? Denne handlingen kan ikke angres.',
      empty: 'Ingen dokumenter registrert.',
      back: 'Tilbake til admin',
    },
    tenders: {
      pageEyebrow: 'NORVIG · ADMIN',
      title: 'Anbudsovervåkning',
      italicSuffix: 'Doffin + admin-status.',
      subtitle: 'Daglig synkronisering fra Doffin med Norvigs CPV-whitelist. Spor status, legg notater, eksportér til CSV.',
      lastFetch: 'Sist hentet {dt}',
      lastFetchSummary: '{n} nye · {u} oppdatert · {e} utløpt',
      refreshNow: 'Hent nå',
      refreshing: 'Henter …',
      exportCsv: 'Eksportér CSV',
      filters: {
        status: 'Status',
        sector: 'Sektor',
        cpv: 'CPV-kode',
        search: 'Søk',
        all: 'Alle',
        apply: 'Bruk filtre',
        reset: 'Tilbakestill',
      },
      cols: {
        status: 'Status',
        title: 'Tittel',
        issuer: 'Oppdragsgiver',
        cpv: 'CPV',
        sector: 'Sektor',
        published: 'Publisert',
        deadline: 'Frist',
        value: 'Verdi',
        actions: 'Handling',
      },
      empty: 'Ingen anbud i basen ennå. Klikk "Hent nå" for å trigge en synkronisering.',
      back: 'Tilbake til admin',
      detail: {
        description: 'Beskrivelse',
        cpvCodes: 'CPV-koder',
        doffinUrl: 'Doffin-lenke',
        statusLabel: 'Sett status',
        notesLabel: 'Notater (internt)',
        save: 'Lagre',
        saving: 'Lagrer …',
        saved: 'Lagret',
        cancel: 'Avbryt',
      },
    },
    tenderInquiries: {
      pageEyebrow: 'NORVIG · ADMIN',
      title: 'Anbuds-leads',
      italicSuffix: 'henvendelser fra publikum.',
      subtitle: 'Lead-er fra "Ta kontakt"-knappen på anbuds-siden. Spor status og notater før konvertering.',
      empty: 'Ingen henvendelser ennå.',
      back: 'Tilbake til admin',
      exportCsv: 'Eksportér CSV',
      filters: {
        status: 'Status',
        search: 'Søk',
        all: 'Alle',
        apply: 'Bruk filtre',
        reset: 'Tilbakestill',
      },
      cols: {
        status: 'Status',
        sender: 'Avsender',
        company: 'Selskap',
        tender: 'Anbud',
        received: 'Mottatt',
        phone: 'Telefon',
        email: 'E-post',
        actions: 'Handling',
      },
      detail: {
        message: 'Melding',
        statusLabel: 'Sett status',
        notesLabel: 'Interne notater',
        save: 'Lagre',
        saving: 'Lagrer …',
      },
      status: {
        new: 'Ny',
        contacted: 'Kontaktet',
        qualified: 'Kvalifisert',
        converted: 'Konvertert',
        dismissed: 'Avvist',
      },
      convertButton: 'Konverter til kunde →',
      alreadyConverted: 'Allerede konvertert',
      goToCustomer: 'Gå til kunden →',
      convertModal: {
        title: 'Konverter til kunde i pipeline',
        intro: 'Følgende informasjon brukes til å opprette ny kommunekonto:',
        company: 'Selskap',
        contact: 'Kontakt',
        emailLabel: 'E-post',
        phone: 'Telefon',
        phoneMissing: 'Ikke oppgitt',
        fromTender: 'Fra anbud',
        doffinRef: 'Doffin-ref',
        inquiryReceived: 'Inquiry mottatt',
        statusLabel: 'Status ved opprettelse',
        priorityLabel: 'Prioritet',
        notesLabel: 'Tilleggsnotat (valgfri)',
        notesPlaceholder: 'F.eks. "Send avtale per e-post i morgen"',
        cancel: 'Avbryt',
        confirm: 'Opprett kunde →',
        creating: 'Oppretter …',
        successToast: (name) => `${name} lagt til i pipeline.`,
        existingToast: (name) => `${name} fantes allerede — attribusjon lagt til.`,
        errorToast: 'Kunne ikke opprette kunde.',
      },
    },
    institutions: {
      back: 'Tilbake til admin',
      title: 'Institusjonsregisteret',
      titleSuffix: 'helse & omsorg.',
      subtitle: 'Nasjonalt register over kommunale helse- og omsorgsinstitusjoner fra Brønnøysundregistrene (næringskodene 87.101–87.104), klassifisert etter type og beriket med kontaktinfo fra kommunen der institusjonen selv mangler den.',
      lastSynced: 'Sist synkronisert',
      sync: 'Synkroniser fra Brønnøysund',
      syncRunning: 'Synkroniserer…',
      exportCsv: 'Eksportér CSV',
      searchPlaceholder: 'Søk på navn, kommune, overordnet enhet eller org.nr …',
      allTypes: 'Alle typer',
      allCodes: 'Alle næringskoder',
      contactAll: 'Kontaktinfo: alle',
      contactWith: 'Med kontaktinfo',
      contactWithout: 'Uten kontaktinfo',
      rows: 'institusjoner',
      viaKommune: 'via kommunen',
      autoSync: 'Nattlig auto-synk (03:00)',
      mapShow: 'Vis kart',
      mapHide: 'Skjul kart',
      mapCount: (n, k) => `${n} institusjoner i ${k} kommuner`,
      mapDot: (n) => `${n} ${n === 1 ? 'institusjon' : 'institusjoner'}`,
      pipelineAdd: 'Til pipeline',
      pipelineAdded: 'I pipeline',
      pipelineCol: 'Lead',
      emptyNoSync: 'Registeret er tomt — kjør «Synkroniser fra Brønnøysund» for å hente inn alle institusjoner.',
      emptyFiltered: 'Ingen institusjoner matcher filtrene.',
      sourceNote: 'Kilde: Brønnøysundregistrenes åpne API for underenheter. Grønt ikon = institusjonens egen kontaktinfo; grått = hentet fra overordnet enhet (kommunen). Klassifiseringen er navnebasert og veiledende.',
      stats: {
        total: 'Institusjoner',
        sykehjem: 'Sykehjem',
        omsorg: 'Omsorgssentre',
        kommuner: 'Kommuner',
        employees: 'Ansatte totalt',
        contact: 'Kontaktdekning',
      },
      cols: {
        name: 'Institusjon',
        type: 'Type',
        kommune: 'Kommune',
        parent: 'Overordnet enhet',
        employees: 'Ansatte',
        contact: 'Kontakt',
      },
      send: {
        selected: (n) => `${n} valgt`,
        cta: 'Send presentasjon',
        clear: 'Nullstill valg',
        title: 'Send presentasjons-e-post',
        desc: (n) => `Sendes til ${n} valgte institusjoner. Institusjoner uten e-postadresse hoppes over automatisk.`,
        body: 'E-posten presenterer Norvig som rekrutteringskanal for helse og omsorg og lenker til /for-kommuner. Institusjoner med egen e-post får den direkte — ellers går den til kommunens postmottak.',
        testLabel: 'Send en test først (valgfritt)',
        testBtn: 'Send test',
        testOk: 'Test-e-post sendt — sjekk innboksen.',
        confirm: (n) => `Send til ${n} institusjoner`,
        sending: 'Sender …',
        result: (s, f, k, a) => `Sendt: ${s} · Feilet: ${f} · Hoppet over (mangler e-post): ${k}${a > 0 ? ` · Nylig presentert (siste 30 dager): ${a}` : ''}`,
        cancel: 'Avbryt',
        sentBadge: (d) => `Presentert ${d}`,
      },
      detail: {
        fields: 'Nøkkelfelter',
        contact: 'Kontaktinfo',
        own: 'egen',
        viaParent: 'fra kommunen',
        address: 'Adresse',
        kommune: 'Kommune',
        parent: 'Overordnet enhet',
        employees: 'Ansatte',
        codes: 'Næringskoder',
        founded: 'Oppstart',
        registered: 'Registrert',
        synced: 'Sist synket',
        email: 'E-post',
        phone: 'Telefon',
        mobile: 'Mobil',
        inactive: 'Inaktiv (fjernet fra BRREG)',
        presentation: 'Presentasjon sendt',
        presentationTo: 'til',
        presentationBy: 'av',
        pipeline: 'Pipeline',
        notInPipeline: 'Ikke i pipeline ennå.',
        addToPipeline: 'Til pipeline',
        openPipeline: 'Åpne i pipeline →',
        priority: 'Prioritet',
        history: 'Historikk',
        noHistory: 'Ingen historikk ennå.',
        notes: 'Notater',
        noNotes: 'Ingen notater ennå.',
        notePlaceholder: 'Skriv et notat …',
        addNote: 'Legg til',
        deleteNote: 'Slett notat',
        close: 'Lukk',
      },
      coverage: {
        show: 'Vis dekningsrapport',
        hide: 'Skjul dekningsrapport',
        title: 'Dekningsrapport',
        subtitle: 'Andel av institusjonene Norvig har nådd — i pipeline eller kontaktet med presentasjon. Følg utviklingen som månedlig vekstmål.',
        reached: 'Dekning totalt',
        reachedCount: 'Nådd / totalt',
        inPipeline: 'I pipeline',
        contacted: 'Kontaktet',
        monthlyTitle: 'Utvikling siste 12 måneder (kumulativt nådd)',
        colKommune: 'Kommune',
        colTotal: 'Institusjoner',
        colPipeline: 'Pipeline',
        colContacted: 'Kontaktet',
        colPct: 'Dekning',
        showAll: (n) => `Vis alle kommuner (+${n})`,
        empty: 'Ingen institusjoner nådd ennå — legg institusjoner i pipeline eller send presentasjoner.',
        weeklyMail: 'Ukentlig dekningsmail (man 08:15)',
        sendNow: 'Send til meg nå',
        sendNowBusy: 'Sender …',
        sendNowOk: (to) => `Sendt til ${to}`,
      },
      sendLog: {
        show: 'Vis utsendelseslogg',
        hide: 'Skjul utsendelseslogg',
        title: 'Utsendelseslogg',
        subtitle: 'Alle sendte presentasjons-e-poster med leverings-, åpnings- og klikkstatus — og om institusjonen har booket en prat.',
        stats: {
          sent: 'Sendt totalt',
          openRate: 'Åpningsgrad',
          clicked: 'Klikket',
          bounced: 'Avvist (bounce)',
          booked: 'Booket prat',
          reminded: 'Purret',
        },
        cols: {
          institution: 'Institusjon',
          recipient: 'Mottaker',
          sentAt: 'Sendt',
          status: 'Status',
        },
        chips: {
          delivered: 'Levert',
          opened: 'Åpnet',
          clicked: 'Klikket',
          bounced: 'Bounce',
          booked: 'Booket prat',
          pending: 'Sendt',
        },
        by: 'av',
        empty: 'Ingen presentasjoner sendt ennå — velg institusjoner i tabellen og klikk «Send presentasjon».',
        loadMore: (n) => `Vis flere (${n} igjen)`,
        openNote: 'Åpnings- og klikkdata kommer fra Resend-webhooks og kan ta noen minutter etter at mottakeren åpner e-posten.',
        remind: 'Send purring',
        remindBusy: 'Sender …',
        remindedChip: (d) => `Purret ${d}`,
        needsFollowup: '14+ dager',
      },
    },
    employersPipeline: {
      pageEyebrow: 'NORVIG · ADMIN',
      title: 'Kommune-oversikt',
      italicSuffix: 'CRM-pipeline.',
      subtitle: 'Oversikt over alle registrerte kommuner med status, prioritet og historikk.',
      back: 'Tilbake til admin',
      exportCsv: 'Eksportér CSV',
      manageStatuses: 'Administrer statuser',
      filters: {
        status: 'Status',
        sector: 'Sektor',
        priority: 'Prioritet',
        source: 'Kilde',
        search: 'Søk navn / orgnr / e-post',
        inactiveDays: 'Sist innlogget før',
        all: 'Alle',
        apply: 'Bruk',
        reset: 'Nullstill',
        anyDays: 'Når som helst',
        days7: '7 dager siden',
        days30: '30 dager siden',
        days90: '90 dager siden',
      },
      sourceLabels: {
        direct: 'Direkte registrering',
        tender_inquiry: 'Fra anbud',
        manual_admin: 'Manuelt opprettet',
      },
      acquisitionBadge: '★ Fra anbud',
      prospectBadge: 'Prospect',
      attributionBlock: {
        title: 'Akquisisjons-info',
        source: 'Kilde',
        tender: 'Anbud',
        doffinRef: 'Doffin-ref',
        inquiryFrom: 'Inquiry mottatt',
        acquiredAt: 'Lagt til pipeline',
        viewInquiry: 'Se opprinnelig inquiry →',
      },
      priority: {
        low: 'Lav',
        normal: 'Normal',
        high: 'Høy',
      },
      cols: {
        status: 'Status',
        org: 'Kommune',
        orgnr: 'Orgnr',
        sector: 'Sektor',
        registered: 'Registrert',
        lastLogin: 'Sist innlogget',
        priority: 'Prioritet',
        actions: 'Handling',
      },
      detail: {
        emailLabel: 'E-post',
        statusLabel: 'Sett status',
        priorityLabel: 'Prioritet',
        notesLabel: 'Interne notater',
        changeNoteLabel: 'Notat om endringen (valgfritt)',
        save: 'Lagre',
        saving: 'Lagrer …',
        history: 'Status-historikk',
        noHistory: 'Ingen historikk ennå.',
        assignedAt: 'Tildelt',
        assignedBy: 'Av',
      },
      empty: 'Ingen kommuner matcher filteret.',
      total: (n) => `${n} kommune${n === 1 ? '' : 'r'}`,
      page: 'Side',
      of: 'av',
      prev: 'Forrige',
      next: 'Neste',
    },
    employerStatuses: {
      pageEyebrow: 'NORVIG · ADMIN',
      title: 'CRM-statuser',
      italicSuffix: 'pipeline-konfigurasjon.',
      subtitle: 'Vedlikehold statuser som brukes for å spore kommuner i salgs- og avtaleløpet.',
      back: 'Tilbake til pipeline',
      addNew: 'Ny status',
      cols: {
        order: 'Rekkefølge',
        slug: 'Slug',
        labelNo: 'Norsk navn',
        labelEn: 'Engelsk navn',
        color: 'Farge',
        default: 'Standard',
        system: 'System',
        actions: 'Handling',
      },
      form: {
        slug: 'Slug (a-z, 0-9, _)',
        labelNo: 'Norsk navn',
        labelEn: 'Engelsk navn',
        color: 'Farge',
        order: 'Rekkefølge',
        isDefault: 'Standard for nye kommuner',
        save: 'Lagre',
        saving: 'Lagrer …',
        cancel: 'Avbryt',
        delete: 'Slett',
        confirmDelete: (label) => `Slett status "${label}"? Dette kan ikke angres.`,
        systemLocked: 'System-statuser kan ikke slettes (men kan redigeres).',
      },
      colorLabels: {
        blue: 'Blå',
        amber: 'Rav',
        emerald: 'Smaragd',
        purple: 'Lilla',
        slate: 'Stål',
        rose: 'Rose',
        teal: 'Petrol',
        indigo: 'Indigo',
        gray: 'Grå',
      },
    },
    employmentReports: {
      title: 'Meldte arbeidsforhold',
      subtitle: 'Fagarbeider-rapporterte arbeidsforhold etter pkt. 5 i forretningsvilkårene.',
      filters: {
        from: 'Fra dato',
        to: 'Til dato',
        contactSource: 'Kilde',
        norvigMember: 'Norvig-medlem',
        reviewed: 'Status',
        all: 'Alle',
        unreviewed: 'Ikke gjennomgått',
        reviewed_: 'Gjennomgått',
        yes: 'Ja',
        no: 'Nei',
        apply: 'Bruk filtre',
        reset: 'Tilbakestill',
      },
      cols: {
        worker: 'Fagarbeider',
        employer: 'Kommune',
        orgnr: 'Org.nr',
        position: 'Stilling',
        start: 'Start',
        type: 'Type',
        source: 'Kilde',
        submitted: 'Meldt',
        member: 'Medlem',
        status: 'Status',
      },
      empty: 'Ingen rapporter matcher filtrene.',
      markReviewed: 'Marker som gjennomgått',
      reviewed: 'Gjennomgått',
      adminNotes: 'Notater',
      save: 'Lagre',
      exportCsv: 'Eksporter CSV',
      totalLabel: 'Totalt',
      unreviewedLabel: 'Ikke gjennomgått',
    },
    hireReports: {
      pageEyebrow: 'NORVIG · ADMIN',
      title: 'Meldte ansettelser',
      italicSuffix: 'revisjon.',
      subtitle: 'Kommuner er pliktige til å varsle Norvig innen 40 dager etter at en fagarbeider er ansatt. Tabellen viser alle innmeldte ansettelser med gebyr-status og admin-handlinger.',
      back: 'Tilbake til admin',
      exportCsv: 'Eksporter CSV',
      empty: 'Ingen meldte ansettelser ennå.',
      filters: {
        sector: 'Sektor',
        feeStatus: 'Gebyr-status',
        reviewed: 'Gjennomgått?',
        source: 'Kontakt-kilde',
        all: 'Alle',
        yes: 'Ja',
        no: 'Nei',
        apply: 'Bruk filtre',
        reset: 'Tilbakestill',
      },
      statuses: {
        pending: 'Avventer',
        invoiced: 'Fakturert',
        paid: 'Betalt',
        waived: 'Frafalt',
        disputed: 'Bestridt',
      },
      sources: {
        viaNorvig: 'Via Norvig',
        outsideNorvig: 'Utenfor Norvig',
      },
      detail: {
        employer: 'Kommune',
        position: 'Stilling',
        startDate: 'Startdato',
        employmentType: 'Ansettelsestype',
        contactSource: 'Kontakt-kilde',
        salary: 'Årslønn',
        notes: 'Notater',
        breakdown: 'Gebyr-beregning',
        months: 'mnd',
      },
      actions: {
        markReviewed: 'Marker som gjennomgått',
        changeStatusTo: 'Endre status til',
        reviewed: 'Markert som gjennomgått',
        statusUpdated: 'Status oppdatert',
        error: 'Kunne ikke oppdatere',
        csvError: 'CSV-eksport feilet',
      },
      showing: 'Viser {from}–{to} av {total}',
      prev: 'Forrige',
      next: 'Neste',
    },
    sectorFees: {
      pageEyebrow: 'NORVIG · ADMIN',
      title: 'Sektor-satser',
      italicSuffix: 'prisliste.',
      subtitle: 'Vedlikehold gjeldende satser for engasjementsgebyr per sektor. Endringer logges i revisjonsporet og gjelder fra det øyeblikket de er lagret.',
      back: 'Tilbake til admin',
      edit: 'Rediger',
      editTitle: 'Rediger sektor-sats',
      perm: 'Fast',
      temp: 'Vikar',
      invoicing: 'Fakturering',
      probation: 'Prøvetid (mnd)',
      terms: 'Betalingsfrist',
      daysNet: 'dager netto',
      notesNo: 'Notater (NO)',
      maxCap: 'Maks {n}',
      minMonths: 'min. {n} mnd',
      minMonthsPlaceholder: 'min. mnd',
      capPlaceholder: 'Maks kr',
      feeNone: 'Ingen gebyr',
      updatedBy: 'Sist endret',
      models: {
        percentage: 'Prosent',
        flat: 'Flat sum',
        hybrid: 'Prosent + tak',
        none: 'Ingen gebyr',
      },
      triggers: {
        after_probation: 'Etter prøvetid',
        contract_signed: 'Ved kontraktsignering',
        first_salary: 'Ved første lønning',
        split_50_50: '50/50 (signering + prøvetid)',
      },
      actions: {
        save: 'Lagre',
        cancel: 'Avbryt',
        saved: 'Lagret',
        error: 'Kunne ikke lagre',
      },
    },
    terms: {
      pageEyebrow: 'NORVIG · ADMIN',
      title: 'Forretningsvilkår',
      italicSuffix: 'versjonshåndtering.',
      subtitle: 'Vedlikehold ToS-tekstene for både fagarbeider og kommune. Lagre utkast først, publiser når du er klar, og marker om brukerne må godkjenne på nytt.',
      back: 'Tilbake til admin',
      tabs: { professional: 'Fagarbeider', employer: 'Kommune' },
      current: 'Gjeldende versjon',
      noCurrent: 'Ingen publisert versjon ennå',
      drafts: 'Utkast',
      noDrafts: 'Ingen utkast for denne dokument-typen + språket.',
      history: 'Historikk',
      noHistory: 'Ingen tidligere versjoner.',
      preview: 'Forhåndsvis',
      view: 'Se',
      createDraft: 'Lag ny versjon',
      continueEditing: 'Fortsett',
      delete: 'Slett',
      saveDraft: 'Lagre utkast',
      publish: 'Publiser',
      close: 'Lukk',
      autosaved: 'Lagret',
      editor: {
        untitled: 'Uten tittel',
        markdown: 'Markdown',
        preview: 'Live forhåndsvisning',
      },
      confirm: {
        deleteDraft: 'Slett dette utkastet permanent?',
      },
      publishConfirm: {
        eyebrow: 'PUBLISER NY VERSJON',
        title: 'Klar til å publisere?',
        subtitle: 'Forrige gjeldende versjon arkiveres automatisk.',
        version: 'Versjon (semver, f.eks. 1.1)',
        summary: 'Endringssammendrag (synlig i revisjon)',
        requiresReacceptance: 'Krev at brukerne godkjenner på nytt',
        warning: 'Alle relevante brukere får tvungen modal ved neste innlogging.',
        estimateLabel: 'Berørte brukere',
        inactiveExcluded: '{n} ekskludert (2-års inaktive)',
        notification: {
          checkbox: 'Send e-postvarsling til berørte brukere',
          helpText: 'Brukerne får en kort, vennlig e-post som forklarer endringen og hvorfor de blir bedt om å godkjenne på nytt ved neste innlogging.',
          warning: 'Brukerne får forced modal uten forhåndsvarsel.',
        },
        cancel: 'Avbryt',
        confirm: 'Publiser nå',
      },
      actions: {
        draftCreated: 'Utkast opprettet',
        draftSaved: 'Utkast lagret',
        draftDeleted: 'Utkast slettet',
        published: 'Publisert som v{v}',
        publishedWithReset: 'Publisert som v{v} · {n} brukere må godkjenne på nytt',
        notificationSent: '{count} varslinger dispatched',
        notificationSkipped: 'Varsling deaktivert',
      },
      errors: {
        noBase: 'Ingen gjeldende versjon å basere utkastet på.',
        draftCreateFailed: 'Kunne ikke opprette utkast.',
        draftSaveFailed: 'Kunne ikke lagre utkast.',
        deleteFailed: 'Kunne ikke slette utkast.',
        publishFailed: 'Publisering feilet.',
      },
    },
  },
  pricing: {
    eyebrow: 'NORVIG · PRISER',
    title: 'Gjennomsiktige satser',
    italicSuffix: 'per sektor.',
    subtitle: 'Norvig tar engasjementsgebyr kun ved bekreftet ansettelse. Registrering, søk i kandidatdatabasen og kommunikasjon med fagarbeidere er gratis.',
    bullets: [
      'Gebyrplikt bortfaller etter 2 års inaktivitet.',
      'Faktureringstidspunkt og prøvetid følger reglene per sektor.',
      'Større volum eller spesialavtaler — ta kontakt direkte.',
    ],
    back: 'Tilbake',
    permanent: 'Fast ansettelse',
    temporary: 'Vikar / midlertidig',
    invoicing: 'Fakturering',
    paymentTerms: 'Betalingsfrist',
    paymentTermsValue: '{n} dager netto',
    ofGrossSalary: 'av første årslønn brutto',
    maxCap: 'maks {n}',
    minDuration: 'min. {n} mnd',
    feeNone: 'Ingen gebyr',
    triggers: {
      after_probation: 'Etter bestått prøvetid ({n} mnd)',
      contract_signed: 'Ved kontraktsignering',
      first_salary: 'Ved første lønning',
      split_50_50: '50 % signering · 50 % etter prøvetid',
    },
    loading: 'Henter prisliste …',
    empty: 'Ingen aktive sektor-satser publisert ennå.',
    cta: {
      eyebrow: 'STORE VOLUM · STRATEGISKE PARTNERSKAP',
      title: 'Spesialavtale?',
      body: 'Ansetter du regelmessig over flere sektorer eller har spesielle behov? Vi skreddersyr modeller — kontakt oss for en samtale.',
      button: 'Kontakt oss',
      termsLink: 'Se forretningsvilkår',
    },
    effectiveFrom: 'Satser gjeldende fra publiseringsdato per sektor — vist øverst i hvert kort.',
  },
  employer: {
    terms: {
      signupCheckbox: 'Jeg har lest og godtar Norvigs forretningsvilkår for kommuner.',
      signupCheckboxLink: 'Les vilkårene',
      profileHeading: 'Forretningsvilkår — kommune',
    },
    hireReport: {
      eyebrow: 'Nº 05 — VARSLINGSPLIKT · MELD ANSETTELSE',
      title: 'Meld ansettelse',
      subtitle: 'Plikt etter vilkår pkt. 5 — varsle innen 40 dager etter at fagarbeideren er ansatt.',
      openButton: 'Meld ny ansettelse',
      modalEyebrow: 'NY MELDING',
      modalTitle: 'Meld ansettelse',
      modalSubtitle: 'Disse opplysningene brukes til revisjon og automatisk gebyr-estimat.',
      close: 'Lukk',
      cancel: 'Avbryt',
      submit: 'Send melding',
      submitting: 'Sender …',
      submittedWithFee: 'Takk — meldingen er mottatt. Estimert gebyr: {fee}.',
      submittedNoFee: 'Takk — meldingen er mottatt. Gebyret beregnes når årslønn er kjent.',
      fields: {
        candidate: 'Kandidat',
        searchInDb: 'Søk i Norvig-database',
        notInDb: 'Ikke i Norvig-database',
        searchPlaceholder: 'Navn eller e-post (min. 2 tegn)',
        namePlaceholder: 'Skriv inn fagarbeiderens fulle navn',
        changeCandidate: 'Bytt kandidat',
        position: 'Stillingstittel',
        startDate: 'Startdato',
        employmentType: 'Ansettelsestype',
        durationMonths: 'Kontraktsvarighet (mnd)',
        salary: 'Årslønn brutto',
        salaryHint: '(valgfri, for gebyr-beregning)',
        contactSource: 'Kontakt opprettet via',
        notes: 'Tilleggsinfo (valgfri)',
        types: {
          fast: 'Fast',
          midlertidig: 'Midlertidig',
          vikar: 'Vikar',
          freelance: 'Freelance',
        },
        sources: {
          viaNorvig: 'Gjennom Norvig',
          outsideNorvig: 'Utenfor Norvig (anbefaling, nettverk, etc.)',
        },
      },
      feeEstimate: {
        heading: 'ESTIMERT GEBYR',
        unknownSalary: 'Oppgi årslønn for å se estimat. Gebyret beregnes uansett ved fakturering.',
        none: 'Ingen gebyr.',
        belowMin: 'Under {n} mnd — ingen gebyr.',
        flat: 'flat sats',
        percentage: '{rate} % av oppgitt årslønn.',
        capped: '{rate} % = {pre} → cap {cap} (anvendt).',
        noSector: 'Ingen sektor satt på kommunekontoen ennå.',
      },
      list: {
        empty: 'Du har ingen meldte ansettelser ennå.',
        statuses: {
          pending: 'Avventer',
          invoiced: 'Fakturert',
          paid: 'Betalt',
          waived: 'Frafalt',
          disputed: 'Bestridt',
        },
      },
      errors: {
        rateLimit: 'Du kan kun melde inn 10 ansettelser per dag. Prøv igjen i morgen.',
        generic: 'Kunne ikke sende melding.',
      },
    },
  },
  // ─── Facelift Fase 2 — Editorial Landing (namespace: landingV2) ───────
  landingV2: {
    hero: {
      eyebrow: 'Rekruttering til Norge',
      headline: 'Skap din nye livsvei\ni Norge.',
      subCopy:
        'Norvig kobler sykepleiere, helsefagarbeidere og andre fagfolk med norske kommuner som verdsetter kompetanse, motivasjon og langsiktige relasjoner.',
      ctaPrimary: 'Registrer deg gratis',
      ctaSecondary: 'For kommuner',
    },
    trust: {
      eyebrow: 'Tillit gjennom struktur',
      body:
        'Norvig etterlever GDPR, autorisasjonskrav fra Helsedirektoratet, og norske arbeidsmiljøstandarder.',
      logos: ['Helsedirektoratet', 'DSB', 'NAV', 'Skatteetaten', 'GDPR'],
    },
    value: {
      pro: {
        eyebrow: 'For fagarbeidere',
        title: 'Finn arbeid der\nomsorgen din verdsettes.',
        body:
          'Ingen mellomledd. Ingen støy. Bare direkte kontakt med kommuner som trenger deg — på sykehjem, i hjemmetjeneste og helsehus.',
        points: [
          'Verifisert autorisasjon og dokumentasjon',
          'Direkte samtaler — ingen agent i midten',
          'Støtte til flytting og norsk arbeidsliv',
        ],
        cta: 'Slik fungerer det for fagarbeidere',
      },
      emp: {
        eyebrow: 'For kommuner',
        title: 'Kandidater som passer\ndin arbeidsplass.',
        body:
          'Norvig kurerer helsepersonell og pedagoger med rett autorisasjon og forventninger. Du bruker tiden på å velge, ikke å sile gjennom støy.',
        points: [
          'Ferdig verifiserte kandidater',
          'Sektor-spesifikk kuratering',
          'Åpen dialog fra første samtale',
        ],
        cta: 'Slik fungerer det for kommuner',
      },
    },
    how: {
      eyebrow: 'Prosessen',
      title: 'Fra registrering til første arbeidsdag.',
      steps: [
        { title: 'Opprett profil', body: 'Legg inn dokumentasjon, språk og arbeidsønsker.' },
        { title: 'Bli verifisert', body: 'Vi bekrefter autorisasjon og bakgrunn før du blir synlig.' },
        { title: 'Match med kommuner', body: 'Møt norske kommuner som ser din profil direkte.' },
        { title: 'Signer kontrakt', body: 'Vi støtter deg gjennom kontrakt, flytting og oppstart.' },
      ],
    },
    sectors: {
      eyebrow: 'Sektorer',
      title: 'Der vi gjør en forskjell.',
      ctaAll: 'Utforsk alle sektorer',
    },
    testimonial: {
      quote:
        'Norvig ga meg mer enn en jobb. Den ga meg en trygg oppstart i et nytt land, og en kommune som forstod hvordan man tar imot noen.',
      attribution: 'Maria K. — Intensivsykepleier, Oslo Universitetssykehus',
      meta: 'Ansatt via Norvig, 2025',
    },
    stories: {
      eyebrow: 'Historier',
      heading: 'Mennesker som fant sin plass.',
      subCopy:
        'Ekte reiser fra hele verden til norske arbeidsplasser. Ikke oppskrifter — bare veier som fungerte.',
      readMore: 'Les historien',
    },
    faq: {
      eyebrow: 'Spørsmål og svar',
      heading: 'De vanligste spørsmålene.',
    },
    norway: {
      eyebrow: 'Om Norge',
      title: 'Et land bygget på tillit,\nnatur og faglig stolthet.',
      body:
        'Norge er ikke bare fjord og fjell. Det er også korte hierarkier, arbeidstakerrettigheter i verdensklasse og et samfunn som tar vare på hverandre.',
      cta: 'Les mer om Norge',
    },
    finalCta: {
      title: 'Ditt neste kapittel starter her.',
      subCopy: 'Registrer deg gratis — ta det første steget mot arbeid i Norge.',
      ctaPrimary: 'Registrer deg gratis',
      loginPrompt: 'Har du allerede en konto?',
      loginLink: 'Logg inn',
    },
  },
};

export default no;
